/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/amazon-daily-statistics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all Amazon daily statistics (paginated) */
        get: operations["getAllStatistics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/amazon-statistics/daily": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get daily Amazon statistics (paginated, sorted by day descending) */
        get: operations["getDaily"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/amazon-statistics/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get aggregated summary of Amazon statistics */
        get: operations["getSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/app-info/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check for app updates
         * @description Determines if an app update is available by comparing the client's version with the latest version stored in the backend.
         */
        get: operations["checkForUpdate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a new category */
        post: operations["createCategory"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category */
        get: operations["getItemResource-category-get"];
        put?: never;
        post?: never;
        /** Delete a category (only if no shops are assigned) */
        delete: operations["deleteCategory"];
        options?: never;
        head?: never;
        /** Update the name, icon and/or color of an existing category */
        patch: operations["updateCategory"];
        trace?: never;
    };
    "/categories/{id}/assigned-shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all shops assigned to a category and identify blocking shops */
        get: operations["getAssignedShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/deassign-shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Remove all shop assignments from a category */
        post: operations["deassignShops"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/parent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-category-Id */
        get: operations["followPropertyReference-category-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/parent/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-category-Id */
        get: operations["followPropertyReference-category-get_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-shop-by-category-Id */
        get: operations["followPropertyReference-category-get_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/shops/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-shop-by-category-Id */
        get: operations["followPropertyReference-category-get_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/shops/{shopId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Assign a shop to a category */
        put: operations["assignShop"];
        post?: never;
        /** Remove a single shop from a category */
        delete: operations["unassignShop"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/subcategories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-category-Id */
        get: operations["followPropertyReference-category-get_4"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/{id}/subcategories/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-category-Id */
        get: operations["followPropertyReference-category-get_5"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/main-with-counts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get main categories with their shop counts and the total shop count */
        get: operations["getMainCategoriesWithCounts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/tree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the full sorted hierarchy of all categories */
        get: operations["getTree"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/categories/with-shop-counts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get category tree with direct and indirect shop counts (admin) */
        get: operations["getAdminTree"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List charities with optional filtering by search term and status */
        get: operations["listCharities"];
        put?: never;
        /** Create a new charity */
        post: operations["createCharity"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{charityId}/certificate-grants/{grantId}/document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete the PDF document for a certificate grant */
        delete: operations["deleteCertificateGrantDocument"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{charityId}/certificate-grants/{grantId}/uploadDocument": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload a PDF document for a certificate grant */
        post: operations["uploadCertificateGrantDocument"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{charityId}/projects": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all projects belonging to a charity */
        get: operations["listProjects"];
        put?: never;
        /** Create a new project for a charity */
        post: operations["createProject"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{charityId}/projects/{projectId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update an existing project's details within a charity */
        patch: operations["updateProject"];
        trace?: never;
    };
    "/charities/{charityId}/projects/{projectId}/logo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete the logo image for a project */
        delete: operations["deleteProjectLogo"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{charityId}/projects/{projectId}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update the status of a project within a charity (e.g. active, inactive) */
        patch: operations["updateProjectStatus"];
        trace?: never;
    };
    "/charities/{charityId}/projects/{projectId}/uploadLogo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload a logo image for a project */
        post: operations["uploadProjectLogo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update an existing charity's details */
        patch: operations["updateCharity"];
        trace?: never;
    };
    "/charities/{id}/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get detailed information about a specific charity by ID */
        get: operations["getCharity"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{id}/eject": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Eject a charity from DZI certification */
        post: operations["ejectFromDzi"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/{id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update the status of a charity (e.g. active, inactive) */
        patch: operations["updateCharityStatus"];
        trace?: never;
    };
    "/charities/{id}/uploadLogo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload a logo image for a charity */
        post: operations["uploadLogo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/certificates": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all available charity certificates */
        get: operations["getCertificates"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/fields-of-work": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all available fields of work for charities */
        get: operations["getFieldsOfWork"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/charities/search/withCertificateGrants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["executeSearch-charity-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/click": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Process an affiliate click and redirect to the merchant URL */
        get: operations["getClick"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/discount-codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List discount codes with filters
         * @description Public: ACTIVE codes, unmasked. Admin: all statuses, unmasked.
         */
        get: operations["listDiscountCodes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/discount-codes/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get discount code by ID */
        get: operations["getDiscountCodeById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/discount-codes/{id}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update discount code status */
        patch: operations["updateDiscountCodeStatus"];
        trace?: never;
    };
    "/discount-codes/byShop/{shopId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get discount codes by shop
         * @description Returns discount codes for a shop (active first, then expired). Codes are returned unmasked.
         */
        get: operations["getByShop"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/discount-codes/latest": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get latest active discount codes
         * @description Returns the latest active discount codes, with favourite shop codes first
         */
        get: operations["getLatestDiscountCodes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/discount-codes/shops-active-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch check shops with active discount codes
         * @description Returns whether each shop ID has active discount codes
         */
        post: operations["checkShopsActiveDiscountCodes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/favourite-shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get favourite shops
         * @description Returns paginated list of favourite shops (recently added first)
         */
        get: operations["getFavourites"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/favourite-shops/{shopId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add shop to favourites
         * @description Adds a shop to the user's favourites (idempotent)
         */
        post: operations["addToFavourites"];
        /**
         * Remove shop from favourites
         * @description Removes a shop from the user's favourites
         */
        delete: operations["removeFromFavourites"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/favourite-shops/check-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch check favourited shops
         * @description Returns whether each shop ID in the request is in the user's favourites
         */
        post: operations["checkBatchFavourited"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/favourite-shops/check/{shopId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check if shop is favourited
         * @description Returns whether a shop is in the user's favourites
         */
        get: operations["checkFavourited"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/favourite-shops/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get favourite shops count
         * @description Returns the number of favourite shops
         */
        get: operations["getFavouritesCount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fee-schedules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all fee schedules (with rules), ordered by effective_from DESC */
        get: operations["listSchedules"];
        put?: never;
        /** Publish a new fee schedule (succeeds the current open-ended schedule) */
        post: operations["publish"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fee-schedules/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a single fee schedule (with rules) by ID */
        get: operations["getSchedule"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fee-schedules/{id}/expire": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Expire (delete) a not-yet-active fee schedule and reopen its predecessor's window
         * @description Only the head (open-ended) schedule may be expired, and only while effective_from > now(). Schedules with a successor, or that have already become active, are rejected with 400/409.
         */
        post: operations["expire"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fee-schedules/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Preview the impact of a draft fee schedule against a window of recent transactions
         * @description Windows <= 30 days run synchronously and return a full result. Larger windows (or > 10 000 transactions) return {status:"pending", jobId}; poll GET /fee-schedules/preview/{jobId} for completion.
         */
        post: operations["preview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fee-schedules/preview/{jobId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Poll the status of a previously-enqueued async preview job */
        get: operations["getPreviewJobStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fieldofworks/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Bulk create fields of work */
        post: operations["createBulk"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/fields-of-work": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all fields of work */
        get: operations["getAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/logo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get logo placement options for a given URL */
        get: operations["getLogoPlaces"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/logo/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Proxy-download a logo image to bypass browser CORS restrictions */
        get: operations["downloadLogo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a paginated list of merchants, optionally filtered by search term or shop website URL */
        get: operations["getAllMerchants"];
        put?: never;
        /** Create a new merchant */
        post: operations["createMerchant"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-merchant */
        get: operations["getItemResource-merchant-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update an existing merchant */
        patch: operations["updateMerchant"];
        trace?: never;
    };
    "/merchants/{id}/contracts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-contract-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/contracts/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-contract-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/network": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-network-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/network/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-network-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/shop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-shop-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get_4"];
        /** Assign or unassign the merchant to a shop. Pass shopId=null to unassign. */
        put: operations["setMerchantShop"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/shop/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-shop-by-merchant-Id */
        get: operations["followPropertyReference-merchant-get_5"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/{id}/withAssociated": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a merchant by ID including its associated data */
        get: operations["getMerchantById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/merchants/byDomain": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all merchants matching the domain of the given URL, ignoring subdomains */
        get: operations["getMerchantsByDomain"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/network-category-mappings": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Upsert a mapping (create or replace) for a network + external category name */
        put: operations["upsertMapping"];
        post?: never;
        /** Delete a mapping for a network + external category name */
        delete: operations["deleteMapping"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/network-category-mappings/by-category": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Perspective 1: all categories with their external merchant category mappings per network */
        get: operations["getMappingsByCategory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/network-category-mappings/by-network/{networkId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Perspective 2: all external merchant categories for a network with their mapped category */
        get: operations["getMappingsByNetwork"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/network-category-mappings/merchant-categories/{networkId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get distinct external merchant category strings for a network (for dropdown) */
        get: operations["getExternalCategoriesForNetwork"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/network-category-mappings/overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get mapping overview: per-network counts of mapped vs. total external merchant categories */
        get: operations["getOverview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/networks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all networks as filter options (requires ROLE_ADMIN) */
        get: operations["getAllNetworks"];
        put?: never;
        /** @description create-network */
        post: operations["postCollectionResource-network-post"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/networks/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** @description update-network */
        put: operations["putItemResource-network-put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** @description patch-network */
        patch: operations["patchItemResource-network-patch"];
        trace?: never;
    };
    "/networks/{id}/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** @description update-merchant-by-network-Id */
        put: operations["createPropertyReference-network-put"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** @description patch-merchant-by-network-Id */
        patch: operations["createPropertyReference-network-patch"];
        trace?: never;
    };
    "/networks/{id}/partnerAccounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** @description update-partneraccount-by-network-Id */
        put: operations["createPropertyReference-network-put_1"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** @description patch-partneraccount-by-network-Id */
        patch: operations["createPropertyReference-network-patch_1"];
        trace?: never;
    };
    "/payments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * List payments
         * @description Returns a paginated list of payments, optionally filtered by network, consistency status, and disbursement date range
         */
        get: operations["listPayments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payments/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get payment detail
         * @description Returns the current version of a payment by ID
         */
        get: operations["getPaymentDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payments/{id}/files/{fileType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Download payment file
         * @description Streams the file content from GCS
         */
        get: operations["downloadFile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payments/{id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get payment history
         * @description Returns all versions of a payment by ID
         */
        get: operations["getPaymentHistory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/payments/{id}/revalidate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Revalidate payment consistency
         * @description Re-runs consistency check against current transactions in the database
         */
        post: operations["revalidateConsistency"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/ping": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Health check for external monitoring */
        get: operations["ping"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        /** Health check for external monitoring */
        head: operations["ping_1"];
        patch?: never;
        trace?: never;
    };
    "/products/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get product by ID
         * @description Returns detailed product information including all merchant offers
         */
        get: operations["findById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/products/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Search for products
         * @description Search for products using text query or product identifiers (GTIN, EAN, MPN, etc.). Returns paginated results with product details and shop information.
         */
        get: operations["searchProducts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["listAllFormsOfMetadata"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["descriptor"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["descriptor_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile/projects": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["descriptor_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/profile/shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["descriptor_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a single project by UUID (light variant)
         * @description get-project
         */
        get: operations["getItemResource-project-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/charity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-charity-by-project-Id */
        get: operations["followPropertyReference-project-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/charity/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-charity-by-project-Id */
        get: operations["followPropertyReference-project-get_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get full project details including charity, organisation, and fields of work */
        get: operations["getProjectDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/fieldsOfWork": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-fieldofwork-by-project-Id */
        get: operations["followPropertyReference-project-get_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/fieldsOfWork/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-fieldofwork-by-project-Id */
        get: operations["followPropertyReference-project-get_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/related": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get related projects from the same charity, excluding the current project */
        get: operations["getRelatedProjects"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/statistics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get statistics for a project including supporter count, total donations, and achievements */
        get: operations["getProjectStatistics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/supporters": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated list of users supporting a specific project */
        get: operations["getProjectSupporters"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/{id}/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated transactions from all users supporting a specific project */
        get: operations["getProjectTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/bySlug/{slug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a single project by slug, with alias-table fallback and canonical-slug hint */
        get: operations["getProjectBySlug"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/bySlug/{slug}/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get full project details by slug, with alias-table fallback and canonical-slug hint */
        get: operations["getProjectDetailBySlug"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Search certified projects by name, description, charity name, or field of work */
        get: operations["search"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/slug/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Preview the slug that would be generated from a given project name */
        post: operations["previewProjectSlug"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/slug/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Validate an admin-proposed project slug for shape and availability */
        post: operations["validateProjectSlug"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/withAssociations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all projects for certified charities with associations */
        get: operations["getProjectsForCertifiedCharities"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/projects/withAssociations/byFieldOfWork": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get certified projects filtered by field of work */
        get: operations["getCertifiedProjectsByField"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/release-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a paginated list of release notes with optional filtering by category, importance, date range, and search term */
        get: operations["getReleaseNotes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/release-notes/{slug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a single release note by its slug */
        get: operations["getReleaseNoteBySlug"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/release-notes/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all available release note categories */
        get: operations["getAvailableCategories"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a paginated list of all shops, optionally filtered by status */
        get: operations["getAllShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get a single shop by UUID
         * @description get-shop
         */
        get: operations["getItemResource-shop-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Admin: partial update of a shop (slug edits write alias rows) */
        patch: operations["updateShop"];
        trace?: never;
    };
    "/shops/{id}/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-shop-Id */
        get: operations["followPropertyReference-shop-get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/categories/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-category-by-shop-Id */
        get: operations["followPropertyReference-shop-get_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/extension-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get extension configuration for a shop per platform */
        get: operations["getExtensionConfig"];
        /** Save extension configuration for a shop per platform */
        put: operations["saveExtensionConfig"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/merchants": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-merchant-by-shop-Id */
        get: operations["followPropertyReference-shop-get_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/merchants/{propertyId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get-merchant-by-shop-Id */
        get: operations["followPropertyReference-shop-get_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/related": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get related shops that share at least one category, excluding the current shop */
        get: operations["getRelatedShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/{id}/uploadLogo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload or replace the logo image for an existing shop */
        post: operations["uploadShopLogo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/byCategory": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated shops for a specific category, sorted by favourites first then by name */
        get: operations["getByCategory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/bySlug/{slug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a single shop by slug, with alias-table fallback and canonical-slug hint */
        get: operations["getShopBySlug"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/extension/updated": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get shops updated after a given timestamp for browser extension sync */
        get: operations["getUpdatedShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/popular": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated popular shops from the featured category */
        get: operations["getPopularShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Search shops by name, description, or category name */
        get: operations["searchShops"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/slug/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Preview the slug that would be generated from a given shop name */
        post: operations["previewShopSlug"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/slug/validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Validate an admin-proposed shop slug for shape and availability */
        post: operations["validateShopSlug"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/withAssociations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated shops with their associated categories and merchants, optionally filtered by name and status */
        get: operations["getShopsWithAssociations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/withAssociations/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a single shop with its associated categories and merchants by ID */
        get: operations["getShopsWithAssociationsById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/shops/withLogo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a new shop with an uploaded logo, category assignments, and optional merchant associations */
        post: operations["createShop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/stripe/webhook": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Stripe webhook receiver for payment events */
        post: operations["handleWebhook"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get paginated transactions, optionally filtered by authenticated user, project, or shop */
        get: operations["getTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get transaction detail with status history (authenticated, owner-only) */
        get: operations["getTransactionDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/{id}/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get all historical versions of a transaction by ID (requires ROLE_ADMIN) */
        get: operations["getTransactionHistory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/has-unattributed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Whether the authenticated user has any unattributed user-facing transaction (gates the first-project backfill warning) */
        get: operations["hasUnattributed"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get aggregated transaction metrics (counts and EUR amounts by status, requires ROLE_ADMIN) */
        get: operations["getMetrics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/metrics/merchants-without-shop": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get merchants that have transactions but no linked shop (requires ROLE_ADMIN) */
        get: operations["getMerchantsWithoutShop"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/metrics/networks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get distinct networks that appear in current transactions, for use as filter options (requires ROLE_ADMIN) */
        get: operations["getNetworkSummaries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/overview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all current transactions for admin view (all statuses, requires ROLE_ADMIN) */
        get: operations["listTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/transactions/recent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get a paginated list of the most recent transactions across all users, used for the landing page */
        get: operations["getRecentTransactions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List all users with optional filtering and pagination */
        get: operations["listUsers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get full user details for admin view (requires ROLE_ADMIN) */
        get: operations["getUserById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{id}/roles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Set roles (custom claims) for a user (requires ROLE_ADMIN) */
        put: operations["setUserRoles"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/{user_id}/claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add custom claims to a user */
        post: operations["addUserClaims"];
        /** Remove custom claims from a user */
        delete: operations["removeUserClaims"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/donations/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get donation summary for the authenticated user */
        get: operations["getDonationSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/extension-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Get a Firebase custom token for the browser extension */
        post: operations["createExtensionToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete the authenticated user's account */
        delete: operations["deleteMe"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/recently-viewed-products": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the list of products recently viewed by the authenticated user */
        get: operations["getRecentlyViewedProducts"];
        put?: never;
        /** Record a product as recently viewed for the authenticated user */
        post: operations["addRecentlyViewedProduct"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/recently-viewed-shops": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the list of shops recently viewed by the authenticated user */
        get: operations["getRecentlyViewedShops"];
        put?: never;
        /** Record a shop as recently viewed for the authenticated user */
        post: operations["addRecentlyViewedShop"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/search-history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the authenticated user's search history */
        get: operations["getSearchHistory"];
        put?: never;
        /** Add a search term to the authenticated user's search history */
        post: operations["addSearchTerm"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/search-history/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Remove a specific search term from the authenticated user's search history by ID */
        delete: operations["removeSearchTerm"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get aggregated user statistics with optional filtering */
        get: operations["getStats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/uploadProfilePicture": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upload a profile picture for the authenticated user */
        post: operations["uploadProfilePicture"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/users/upsert": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a user profile */
        post: operations["upsert"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/vouchers/payment-intent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create a Stripe PaymentIntent for a voucher purchase */
        post: operations["createPaymentIntent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/vouchers/purchases": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List purchased vouchers for the authenticated user */
        get: operations["getPurchases"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/wishlist": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get wishlist
         * @description Returns paginated list of wishlisted products (recently added first)
         */
        get: operations["getWishlist"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/wishlist/{productId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add product to wishlist
         * @description Adds a product to the user's wishlist (idempotent)
         */
        post: operations["addToWishlist"];
        /**
         * Remove product from wishlist
         * @description Removes a product from the user's wishlist
         */
        delete: operations["removeFromWishlist"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/wishlist/check-batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch check wishlisted products
         * @description Returns whether each product ID in the request is in the user's wishlist
         */
        post: operations["checkBatchWishlisted"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/wishlist/check/{productId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Check if product is wishlisted
         * @description Returns whether a product is in the user's wishlist
         */
        get: operations["checkWishlisted"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/wishlist/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get wishlist count
         * @description Returns the number of items in the user's wishlist
         */
        get: operations["getWishlistCount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        AbstractJsonSchemaPropertyObject: {
            readOnly?: boolean;
            title?: string;
        };
        AddRecentlyViewedProductRequest: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            productId: string;
        };
        AddRecentlyViewedShopRequest: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            shopId: string;
        };
        Address: {
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            countryCode?: string;
            postalCode?: string;
            state?: string;
        };
        AddSearchTermRequest: {
            /** Format: uuid */
            id: string;
            term: string;
        };
        AmazonDailyStatisticDto: {
            /** Format: int32 */
            clicks: number;
            conversionRate: number;
            /** Format: date-time */
            createdAt: string;
            /** Format: date */
            day: string;
            hvaTotalEarnings: number;
            /** Format: int32 */
            returnedItems: number;
            /** Format: int32 */
            shippedItems: number;
            totalEarnings: number;
            /** Format: int32 */
            totalOrderedItems: number;
            totalOrderedRevenue: number;
            totalRevenue: number;
            /** Format: date-time */
            updatedAt: string;
        };
        AmazonDailyStatisticPublicDto: {
            /** Format: date */
            day: string;
            /** Format: int32 */
            returnedItems: number;
            /** Format: int32 */
            shippedItems: number;
            totalEarnings: number;
            /** Format: int32 */
            totalOrderedItems: number;
            totalRevenue: number;
        };
        AmazonStatisticsSummaryDto: {
            monthEarnings: number;
            weekEarnings: number;
            yearEarnings: number;
        };
        /** @enum {string} */
        AppPlatform: AppPlatform;
        /** @description Response containing app update information */
        AppUpdateCheckResponse: {
            /**
             * @description Whether the update is forced (user must update)
             * @example true
             */
            forceUpdate: boolean;
            /**
             * @description Latest version available
             * @example 1.4.0
             */
            latestVersion: string;
            /**
             * Format: date-time
             * @description Release date of the latest version
             * @example 2026-01-04T00:00:00Z
             */
            releaseDate: string;
            /**
             * @description Whether an update is needed
             * @example true
             */
            updateNeeded: boolean;
        };
        AssignedShopDto: {
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
        };
        BasketData: {
            entries?: components["schemas"]["BasketEntryData"][];
        };
        /** @enum {string} */
        BasketDataStatus: BasketDataStatus;
        BasketEntryData: {
            brandName?: string;
            category?: string;
            commissionAmount?: number;
            currencyRate?: number;
            externalProductId?: string;
            originalCommissionAmount?: number;
            originalShippingCosts?: number;
            originalTotalPrice?: number;
            originalUnitPrice?: number;
            productName?: string;
            /** Format: uuid */
            productOfferId?: string;
            /** Format: int32 */
            quantity?: number;
            seller?: string;
            shippingCosts?: number;
            sku?: string;
            status?: components["schemas"]["BasketDataStatus"];
            taxAmount?: number;
            totalPrice?: number;
            unitPrice?: number;
        };
        CategoriesWithTotalCountDto: {
            categories: components["schemas"]["MainCategoryWithCountDto"][];
            /** Format: int32 */
            totalShopCount: number;
        };
        Category: {
            color: string;
            /** Format: date-time */
            createdAt?: string;
            icon: string;
            /** Format: uuid */
            id: string;
            name: string;
            parent?: components["schemas"]["Category"];
            shops?: components["schemas"]["Shop"][];
            subcategories: components["schemas"]["Category"][];
            /** Format: date-time */
            updatedAt?: string;
        };
        CategoryAdminTreeDto: {
            color: string;
            /** Format: int32 */
            directShopCount: number;
            icon?: string;
            /** Format: uuid */
            id: string;
            /** Format: int32 */
            indirectShopCount: number;
            name: string;
            /** Format: uuid */
            parentId?: string;
            subcategories: components["schemas"]["CategoryAdminTreeDto"][];
        };
        CategoryAssignedShopsDto: {
            assignedShops: components["schemas"]["AssignedShopDto"][];
            blockingShops: components["schemas"]["AssignedShopDto"][];
        };
        CategoryDto: {
            color: string;
            icon?: string;
            /** Format: uuid */
            id: string;
            name: string;
        };
        CategoryMappingRowDto: {
            /** Format: uuid */
            categoryId: string;
            categoryName: string;
            mappingsByNetwork: {
                [key: string]: string[];
            };
            /** Format: uuid */
            parentId?: string;
        };
        CategoryTreeDto: {
            icon?: string;
            /** Format: uuid */
            id: string;
            name: string;
            subcategories: components["schemas"]["CategoryTreeDto"][];
        };
        CertificateAdminDto: {
            /** Format: uuid */
            id: string;
            title: string;
        };
        CertificateGrantAdminDto: {
            /** Format: uuid */
            certificateId: string;
            certificateTitle?: string;
            certificateUrl?: string;
            description?: string;
            /** Format: date */
            grantedAt?: string;
            /** Format: uuid */
            id: string;
            overheadCosts?: components["schemas"]["OverheadCostType"];
        };
        CertificateGrantDto: {
            certificateTitle?: string;
            certificateUrl?: string;
            description?: string;
            /** Format: date */
            grantedAt?: string;
            /** Format: uuid */
            id?: string;
            overheadCosts?: components["schemas"]["OverheadCostType"];
        };
        CertificateGrantInputDto: {
            /** Format: uuid */
            certificateId: string;
            certificateUrl?: string;
            description?: string;
            /** Format: date */
            grantedAt?: string;
            /** Format: uuid */
            id: string;
            overheadCosts?: components["schemas"]["OverheadCostType"];
        };
        CharityAdminDetailDto: {
            addressLine1?: string;
            addressLine2?: string;
            certificateGrants: components["schemas"]["CertificateGrantAdminDto"][];
            city?: string;
            countryCode?: string;
            /** Format: date-time */
            createdAt?: string;
            currencyCode?: string;
            description?: string;
            displayName?: string;
            email?: string;
            /** Format: int32 */
            employees?: number;
            fieldsOfWork: components["schemas"]["FieldOfWorkDto"][];
            focusedCountryCodes?: string[];
            /** Format: date */
            founded?: string;
            fundraisingIncome?: number;
            governingBody?: components["schemas"]["GoverningBody"];
            /** Format: uuid */
            id: string;
            legalForm?: components["schemas"]["LegalForm"];
            logoUrl?: string;
            managedByDzi: boolean;
            name?: string;
            phoneNumber?: string;
            postalCode?: string;
            projects: components["schemas"]["ProjectAdminDto"][];
            registrationNumber?: string;
            reportingYear?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            state?: string;
            status: components["schemas"]["CharityStatus"];
            taxDeductible?: boolean;
            taxLiable?: boolean;
            taxRegistrationNumber?: string;
            totalExpenses?: number;
            totalIncome?: number;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: int32 */
            volunteers?: number;
            /** Format: int32 */
            votingMembers?: number;
            website?: string;
            worldview?: components["schemas"]["Worldview"];
        };
        CharityAdminListDto: {
            city?: string;
            countryCode?: string;
            /** Format: date-time */
            createdAt?: string;
            displayName?: string;
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            managedByDzi: boolean;
            name: string;
            /** Format: int32 */
            projectCount: number;
            status: components["schemas"]["CharityStatus"];
            /** Format: date-time */
            updatedAt?: string;
            website?: string;
        };
        CharityDto: {
            certificateGrants?: components["schemas"]["CertificateGrantDto"][];
            /** Format: date */
            founded?: string;
            fundraisingIncome?: number;
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            organisation: components["schemas"]["OrganisationTinyDto"];
            socialMedia?: components["schemas"]["SocialMedia"][];
            totalExpenses?: number;
            totalIncome?: number;
            website?: string;
        };
        /** @enum {string} */
        CharityStatus: CharityStatus;
        Click: {
            agentClass?: string;
            agentName?: string;
            agentVersion?: string;
            clickHash: string;
            /** Format: int64 */
            clickId: number;
            clientClass?: components["schemas"]["ClientClass"];
            /** Format: uuid */
            clientId?: string;
            clientVersion?: string;
            /** Format: uuid */
            contract?: string;
            /** Format: date-time */
            createdAt: string;
            deviceBrand?: string;
            deviceClass?: string;
            deviceHeight?: string;
            deviceName?: string;
            deviceOrientation?: string;
            devicePixelRatio?: string;
            deviceThemeMode?: string;
            deviceWidth?: string;
            externalClickIds?: {
                [key: string]: string;
            };
            geoCityName?: string;
            geoCountryIsoCode?: string;
            geoCountryName?: string;
            /** Format: double */
            geoLocationLatitude?: number;
            /** Format: double */
            geoLocationLongitude?: number;
            geoPostalCode?: string;
            geoSubdivisionIsoCode?: string;
            geoSubdivisionName?: string;
            headers: {
                [key: string]: string;
            };
            ipAddress: string;
            operatingSystemClass?: string;
            operatingSystemName?: string;
            operatingSystemVersion?: string;
            pageAction?: string;
            pageTitle?: string;
            pageUrl?: string;
            productOffer?: components["schemas"]["ProductOffer"];
            /** Format: uuid */
            project?: string;
            redirectUrl: string;
            refererUrl?: string;
            targetUrl: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: uuid */
            user?: string;
            userAgent: {
                [key: string]: string;
            };
            userLocale?: string;
            userTimeZone?: string;
            utmCampaign?: string;
            utmContent?: string;
            utmMedium?: string;
            utmSource?: string;
            utmTerm?: string;
        };
        ClickRequest: {
            agentClass?: string;
            agentName?: string;
            agentVersion?: string;
            clickId?: string;
            clientClass?: components["schemas"]["ClientClass"];
            /** Format: uuid */
            clientId?: string;
            clientVersion?: string;
            dclid?: string;
            debug?: boolean;
            deviceBrand?: string;
            deviceClass?: string;
            deviceHeight?: string;
            deviceName?: string;
            deviceOrientation?: string;
            devicePixelRatio?: string;
            deviceThemeMode?: string;
            deviceWidth?: string;
            fbclid?: string;
            gbraid?: string;
            gclid?: string;
            gclsrc?: string;
            ipAddress?: string;
            lifatid?: string;
            msclkid?: string;
            operatingSystemClass?: string;
            operatingSystemName?: string;
            operatingSystemVersion?: string;
            pageAction?: string;
            pageTitle?: string;
            pageUrl?: string;
            /** Format: uuid */
            productOfferId?: string;
            refererUrl?: string;
            targetUrl?: string;
            ttclid?: string;
            twclid?: string;
            userId?: string;
            userLocale?: string;
            userTimeZone?: string;
            utmCampaign?: string;
            utmContent?: string;
            utmMedium?: string;
            utmSource?: string;
            utmTerm?: string;
            wbraid?: string;
            yclid?: string;
        };
        /** @enum {string} */
        ClientClass: ClientClass;
        CollectionModelCategory: {
            content?: components["schemas"]["Category"][];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelContract: {
            content?: components["schemas"]["Contract"][];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelFieldOfWork: {
            content?: components["schemas"]["FieldOfWork"][];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelMerchant: {
            content?: components["schemas"]["Merchant"][];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelObject: {
            content?: Record<string, never>[];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelPartnerAccount: {
            content?: components["schemas"]["PartnerAccount"][];
            links?: components["schemas"]["Link"][];
        };
        CollectionModelShop: {
            content?: components["schemas"]["Shop"][];
            links?: components["schemas"]["Link"][];
        };
        CommissionGroup: {
            description?: string;
            groupType: string;
            rules?: (components["schemas"]["CommissionRule"] | components["schemas"]["CPACommissionRule"] | components["schemas"]["CPCCommissionRule"])[];
        };
        CommissionRangeSummary: {
            max?: number;
            min?: number;
            type?: components["schemas"]["CommissionSummaryType"];
        };
        CommissionRule: {
            conditions?: components["schemas"]["RuleCondition"][];
            ruleType: string;
        };
        CommissionStructure: {
            groups?: (components["schemas"]["CommissionGroup"] | components["schemas"]["CPACommissionGroup"] | components["schemas"]["CPCCommissionGroup"])[];
        };
        /** @enum {string} */
        CommissionSummaryType: CommissionSummaryType;
        /** @enum {string} */
        ConditionType: ConditionType;
        Contract: {
            commissionRangeSummary?: components["schemas"]["CommissionRangeSummary"];
            commissionStructure?: components["schemas"]["CommissionStructure"];
            contractType?: components["schemas"]["ContractType"];
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            id: string;
            kpis?: components["schemas"]["ContractKPIs"];
            merchant: components["schemas"]["Merchant"];
            merchantClickProductUrl?: string;
            merchantClickUrl?: string;
            /** Format: uuid */
            network: string;
            partnerAccount: components["schemas"]["PartnerAccount"];
            status?: components["schemas"]["ContractStatus"];
            /** Format: date-time */
            updatedAt?: string;
        };
        ContractDto: {
            commissionRangeSummary?: components["schemas"]["CommissionRangeSummary"];
            contractType?: components["schemas"]["ContractType"];
            /** Format: date-time */
            createdAt: string;
            /** Format: uuid */
            id: string;
            status?: components["schemas"]["ContractStatus"];
            /** Format: date-time */
            updatedAt: string;
        };
        ContractKPIs: {
            acr?: number;
            /** Format: int32 */
            averagePaymentDays?: number;
            /** Format: int32 */
            averageValidationDays?: number;
            ccr?: number;
            crr?: number;
            ctr?: number;
            cvr?: number;
            epc?: number;
        };
        /** @enum {string} */
        ContractStatus: ContractStatus;
        /** @enum {string} */
        ContractType: ContractType;
        CPACommissionGroup: {
            groupType: "CPACommissionGroup";
        } & Omit<components["schemas"]["CommissionGroup"], "groupType">;
        CPACommissionRule: {
            ruleType: "CPACommissionRule";
        } & (Omit<components["schemas"]["CommissionRule"], "ruleType"> & {
            commissionCap?: string;
            fixedAmount?: string;
            percentage?: string;
        });
        CPCCommissionGroup: {
            groupType: "CPCCommissionGroup";
        } & Omit<components["schemas"]["CommissionGroup"], "groupType">;
        CPCCommissionRule: {
            ruleType: "CPCCommissionRule";
        } & (Omit<components["schemas"]["CommissionRule"], "ruleType"> & {
            fixedAmount?: string;
            maxAmount?: string;
            minAmount?: string;
        });
        CreateCategoryRequest: {
            icon?: string;
            /** Format: uuid */
            id: string;
            name: string;
            /** Format: uuid */
            parentId?: string;
        };
        CreateCharityRequest: {
            addressLine1?: string;
            addressLine2?: string;
            certificateGrants?: components["schemas"]["CertificateGrantInputDto"][];
            city?: string;
            countryCode: string;
            currencyCode?: string;
            description?: string;
            displayName: string;
            email?: string;
            /** Format: int32 */
            employees?: number;
            fieldOfWorkIds?: string[];
            focusedCountryCodes?: string[];
            /** Format: date */
            founded?: string;
            fundraisingIncome?: number;
            governingBody?: string;
            legalForm?: string;
            logoUrl?: string;
            name: string;
            phoneNumber?: string;
            postalCode?: string;
            registrationNumber?: string;
            reportingYear?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            state?: string;
            taxDeductible?: boolean;
            taxLiable?: boolean;
            taxRegistrationNumber?: string;
            totalExpenses?: number;
            totalIncome?: number;
            /** Format: int32 */
            volunteers?: number;
            /** Format: int32 */
            votingMembers?: number;
            website?: string;
            worldview?: string;
        };
        CreateMerchantRequest: {
            categories?: string[];
            currencyCode?: string;
            description?: string;
            email?: string;
            externalId: string;
            name: string;
            /** Format: uuid */
            networkId: string;
            regionCountryCodes?: string[];
            status?: components["schemas"]["MerchantStatus"];
            websiteUrl: string;
        };
        CreateProjectRequest: {
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            countryCode?: string;
            description?: string;
            email?: string;
            /** Format: date */
            endDate?: string;
            fieldOfWorkIds?: string[];
            focusedCountryCodes?: string[];
            name: string;
            phoneNumber?: string;
            postalCode?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            /** Format: date */
            startDate?: string;
            state?: string;
            website?: string;
        };
        /** @enum {string} */
        CustomClaim: CustomClaim;
        /** @enum {string} */
        DatafeedCompression: DatafeedCompression;
        /** @enum {string} */
        DatafeedFormat: DatafeedFormat;
        DiscountCodeDetailDto: {
            attributable?: boolean;
            code?: string;
            /** Format: date-time */
            createdAt?: string;
            currencyCode?: string;
            deepLink?: string;
            description?: string;
            discountAmount?: number;
            discountPercentage?: number;
            /** Format: date-time */
            endsAt?: string;
            exclusive?: boolean;
            expiringSoon?: boolean;
            /** Format: uuid */
            id?: string;
            minimumOrderValue?: number;
            networkName?: string;
            /** Format: uuid */
            shopId?: string;
            shopLogoUrl?: string;
            shopName?: string;
            shopSlug?: string;
            /** Format: date-time */
            startsAt?: string;
            status?: components["schemas"]["DiscountCodeStatus"];
            terms?: string;
            title?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        DiscountCodeDto: {
            attributable?: boolean;
            code?: string;
            currencyCode?: string;
            deepLink?: string;
            description?: string;
            discountAmount?: number;
            discountPercentage?: number;
            /** Format: date-time */
            endsAt?: string;
            exclusive?: boolean;
            expiringSoon?: boolean;
            /** Format: uuid */
            id?: string;
            minimumOrderValue?: number;
            /** Format: date-time */
            startsAt?: string;
            status?: components["schemas"]["DiscountCodeStatus"];
            terms?: string;
            title?: string;
        };
        DiscountCodeShopBatchCheckRequest: {
            shopIds?: string[];
        };
        DiscountCodeShopBatchCheckResponse: {
            results?: {
                [key: string]: boolean;
            };
        };
        /** @enum {string} */
        DiscountCodeStatus: DiscountCodeStatus;
        /** @enum {string} */
        EmailSentStatus: EmailSentStatus;
        EntityModelCategory: {
            color: string;
            /** Format: date-time */
            createdAt?: string;
            icon: string;
            /** Format: uuid */
            id: string;
            links?: components["schemas"]["Link"][];
            name: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        EntityModelCharity: {
            /** Format: date-time */
            createdAt?: string;
            /** Format: int32 */
            employees?: number;
            focusedCountryCodes?: string[];
            /** Format: date */
            founded?: string;
            fundraisingIncome?: number;
            governingBody?: components["schemas"]["GoverningBody"];
            /** Format: uuid */
            id: string;
            links?: components["schemas"]["Link"][];
            managedByDzi: boolean;
            organisation: components["schemas"]["Organisation"];
            reportingYear?: string;
            status: components["schemas"]["CharityStatus"];
            taxDeductible?: boolean;
            totalExpenses?: number;
            totalIncome?: number;
            /** Format: date-time */
            updatedAt?: string;
            /** Format: int32 */
            volunteers?: number;
            /** Format: int32 */
            votingMembers?: number;
            worldview?: components["schemas"]["Worldview"];
        };
        EntityModelMerchant: {
            categories?: string[];
            /** Format: date-time */
            createdAt?: string;
            currencyCode?: string;
            description?: string;
            domainName?: string;
            /** Format: email */
            email?: string;
            externalId: string;
            /** Format: uuid */
            id: string;
            links?: components["schemas"]["Link"][];
            logoUrl?: string;
            name: string;
            regionCountryCodes: string[];
            status?: components["schemas"]["MerchantStatus"];
            transactions?: components["schemas"]["Transaction"][];
            /** Format: date-time */
            updatedAt?: string;
            websiteUrl?: string;
        };
        EntityModelNetwork: {
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            id: string;
            links?: components["schemas"]["Link"][];
            organisation: components["schemas"]["Organisation"];
            softwareVendor?: components["schemas"]["SoftwareVendor"];
            type?: components["schemas"]["NetworkType"];
            /** Format: date-time */
            updatedAt?: string;
        };
        EntityModelProject: {
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            countryCode?: string;
            /** Format: date-time */
            createdAt?: string;
            description?: string;
            /** Format: email */
            email?: string;
            /** Format: date */
            endDate?: string;
            focusedCountryCodes?: string[];
            /** Format: uuid */
            id: string;
            links?: components["schemas"]["Link"][];
            logoUrl?: string;
            name: string;
            phoneNumber?: string;
            postalCode?: string;
            slug: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            /** Format: date */
            startDate?: string;
            state?: string;
            status: components["schemas"]["ProjectStatus"];
            /** Format: date-time */
            updatedAt?: string;
            website?: string;
        };
        EntityModelShop: {
            /** Format: date-time */
            createdAt?: string;
            description: string;
            domainName: string;
            /** Format: uuid */
            id: string;
            internalNotes?: string;
            links?: components["schemas"]["Link"][];
            logoUrl: string;
            monetized?: boolean;
            name: string;
            /** Format: double */
            popularityScore: number;
            slug: string;
            status: components["schemas"]["ShopStatus"];
            /** Format: date-time */
            updatedAt?: string;
            websiteUrl: string;
        };
        /** @description Custom Firebase token for browser extension authentication */
        ExtensionTokenResponse: {
            /** @description Firebase custom token for signInWithCustomToken() */
            customToken: string;
            /** @description Firebase UID of the authenticated user */
            firebaseUid: string;
        };
        ExternalCategoryMappingRowDto: {
            /** Format: uuid */
            categoryId?: string;
            categoryName?: string;
            externalCategoryName: string;
        };
        FavouriteShopBatchCheckRequest: {
            shopIds?: string[];
        };
        FavouriteShopBatchCheckResponse: {
            results?: {
                [key: string]: boolean;
            };
        };
        FavouriteShopCheckResponse: {
            favourited?: boolean;
        };
        FavouriteShopCountResponse: {
            /** Format: int64 */
            count?: number;
        };
        FeePreviewRowDto: {
            contractType?: string;
            delta: number;
            gross: number;
            newFee: number;
            /** Format: uuid */
            newRuleId: string;
            oldFee: number;
            /** Format: uuid */
            oldRuleId: string;
            /** Format: uuid */
            transactionId: string;
            userFacing: boolean;
        };
        FeeRuleAdminCreateRequest: {
            conditionContractType?: components["schemas"]["ContractType"];
            conditionUserFacing?: boolean;
            feeFixedAmountEur: number;
            feePercentage: number;
            /** Format: uuid */
            id: string;
            name: string;
            /** Format: int32 */
            priority: number;
        };
        FeeRuleAdminDto: {
            conditionContractType?: components["schemas"]["ContractType"];
            conditionUserFacing?: boolean;
            feeFixedAmountEur: number;
            feePercentage: number;
            /** Format: uuid */
            id: string;
            name: string;
            /** Format: int32 */
            priority: number;
        };
        FeeScheduleAdminCreateRequest: {
            description?: string;
            /** Format: date-time */
            effectiveFrom: string;
            /** Format: uuid */
            id: string;
            name: string;
            rules: components["schemas"]["FeeRuleAdminCreateRequest"][];
        };
        FeeScheduleAdminDto: {
            /** Format: uuid */
            createdByUserId?: string;
            description?: string;
            /** Format: date-time */
            effectiveFrom: string;
            /** Format: date-time */
            effectiveTo?: string;
            /** Format: uuid */
            id: string;
            name: string;
            rules: components["schemas"]["FeeRuleAdminDto"][];
        };
        FeeSchedulePreviewJobStatusResponse: {
            error?: string;
            /** Format: uuid */
            jobId: string;
            result?: components["schemas"]["FeeSchedulePreviewResponse"];
            status: string;
        };
        FeeSchedulePreviewRequest: {
            draft: components["schemas"]["FeeScheduleAdminCreateRequest"];
            /** Format: int32 */
            sampleSize?: number;
            /** Format: date-time */
            windowEnd?: string;
            /** Format: date-time */
            windowStart?: string;
        };
        FeeSchedulePreviewResponse: {
            disclaimer: string;
            /**
             * Format: decimal
             * @example 123.45
             */
            extrapolatedShift: number;
            /** Format: int32 */
            sampleCount: number;
            sampleRows: components["schemas"]["FeePreviewRowDto"][];
            status: string;
            /**
             * Format: decimal
             * @example 123.45
             */
            totalSampleShift: number;
            /** Format: int64 */
            totalWindowCount: number;
        };
        FieldOfWork: {
            color: string;
            /** Format: date-time */
            createdAt?: string;
            icon: string;
            /** Format: uuid */
            id: string;
            title: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        FieldOfWorkDto: {
            color: string;
            icon: string;
            /** Format: uuid */
            id: string;
            title: string;
        };
        /** @enum {string} */
        FileType: FileType;
        /** @enum {string} */
        Gender: Gender;
        /** @enum {string} */
        GoverningBody: GoverningBody;
        HasUnattributedTransactionsDto: {
            hasUnattributed: boolean;
        };
        IdentityProvider: {
            displayName?: string;
            email?: string;
            id?: string;
            phoneNumber?: string;
            photoUrl?: string;
            uid?: string;
        };
        Item: {
            properties?: {
                [key: string]: components["schemas"]["AbstractJsonSchemaPropertyObject"];
            };
            requiredProperties?: string[];
            type?: string;
        };
        JsonSchema: {
            $schema?: string;
            definitions?: {
                [key: string]: components["schemas"]["Item"];
            };
            description?: string;
            properties?: {
                [key: string]: components["schemas"]["AbstractJsonSchemaPropertyObject"];
            };
            requiredProperties?: string[];
            title?: string;
            type?: string;
        };
        LatestDiscountCodeDto: {
            /** Format: date-time */
            endsAt?: string;
            /** Format: uuid */
            id?: string;
            /** Format: uuid */
            shopId?: string;
            shopLogoUrl?: string;
            shopName?: string;
            title?: string;
        };
        /** @enum {string} */
        LegalForm: LegalForm;
        Link: {
            deprecation?: string;
            href?: string;
            hreflang?: string;
            media?: string;
            name?: string;
            profile?: string;
            rel?: string;
            title?: string;
            type?: string;
        };
        LogoResponse: {
            /** Format: double */
            score?: number;
            /** Format: int32 */
            source?: number;
            sourceLabel: string;
            type: string;
            url: string;
        };
        MainCategoryWithCountDto: {
            color: string;
            icon?: string;
            /** Format: uuid */
            id: string;
            name: string;
            /** Format: int32 */
            shopCount: number;
        };
        /** @enum {string} */
        MatchUsedColumn: MatchUsedColumn;
        Merchant: {
            categories?: string[];
            contracts?: components["schemas"]["Contract"][];
            /** Format: date-time */
            createdAt?: string;
            currencyCode?: string;
            description?: string;
            domainName?: string;
            /** Format: email */
            email?: string;
            externalId: string;
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
            network: components["schemas"]["Network"];
            regionCountryCodes: string[];
            shop?: components["schemas"]["Shop"];
            status?: components["schemas"]["MerchantStatus"];
            transactions?: components["schemas"]["Transaction"][];
            /** Format: date-time */
            updatedAt?: string;
            websiteUrl?: string;
        };
        MerchantDto: {
            categories: string[];
            contracts: components["schemas"]["ContractDto"][];
            /** Format: date-time */
            createdAt: string;
            currencyCode?: string;
            description?: string;
            domainName?: string;
            email?: string;
            externalId: string;
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
            network: components["schemas"]["NetworkDto"];
            regionCountryCodes: string[];
            shop?: components["schemas"]["ShopPlainDto"];
            status?: components["schemas"]["MerchantStatus"];
            /** Format: date-time */
            updatedAt: string;
            websiteUrl?: string;
        };
        MerchantFeed: {
            /** Format: date-time */
            createdAt?: string;
            datafeedCompression?: components["schemas"]["DatafeedCompression"];
            datafeedFormat: components["schemas"]["DatafeedFormat"];
            externalFeedId: string;
            /** Format: uuid */
            feedId: string;
            feedName?: string;
            language?: string;
            /** Format: date-time */
            lastChecked?: string;
            /** Format: date-time */
            lastImported?: string;
            merchant: components["schemas"]["Merchant"];
            network: components["schemas"]["Network"];
            /** Format: int32 */
            noOfProducts?: number;
            orCreateProcessing?: components["schemas"]["MerchantFeedProcessing"];
            processing?: components["schemas"]["MerchantFeedProcessing"];
            /** Format: date-time */
            updatedAt?: string;
            url?: string;
            vertical?: string;
        };
        MerchantFeedProcessing: {
            /** Format: int32 */
            batchCount?: number;
            /** Format: date-time */
            createdAt?: string;
            /** Format: int32 */
            durationMillis?: number;
            /** Format: uuid */
            feedId: string;
            /** Format: uuid */
            feedProcessingId: string;
            fileHash?: string;
            fileName?: string;
            /** Format: date-time */
            lastUpdate?: string;
            merchantFeed?: components["schemas"]["MerchantFeed"];
            message?: string;
            network?: components["schemas"]["Network"];
            /** Format: int32 */
            noOfProducts?: number;
            /** Format: int32 */
            skippedCount?: number;
            status?: components["schemas"]["ProcessedStatus"];
            /** Format: date-time */
            updatedAt?: string;
            /** Format: int32 */
            variationCount?: number;
        };
        /** @enum {string} */
        MerchantStatus: MerchantStatus;
        MissingShopMerchantDto: {
            /** Format: int64 */
            count: number;
            /** Format: uuid */
            merchantId: string;
            merchantName: string;
            totalCommissionEur: number;
            totalPriceEur: number;
        };
        Network: {
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            id: string;
            merchants?: components["schemas"]["Merchant"][];
            organisation: components["schemas"]["Organisation"];
            partnerAccounts?: components["schemas"]["PartnerAccount"][];
            softwareVendor?: components["schemas"]["SoftwareVendor"];
            type?: components["schemas"]["NetworkType"];
            /** Format: date-time */
            updatedAt?: string;
        };
        NetworkDto: {
            /** Format: uuid */
            networkId: string;
            organisation: components["schemas"]["OrganisationTinyDto"];
        };
        NetworkMappingOverviewDto: {
            /** Format: int32 */
            mappedCount: number;
            /** Format: uuid */
            networkId: string;
            networkName: string;
            /** Format: int32 */
            totalExternalCategories: number;
            /** Format: int32 */
            unmappedCount: number;
        };
        NetworkRequestBody: {
            /** Format: date-time */
            createdAt?: string;
            /** Format: uuid */
            id: string;
            merchants?: string[];
            organisation: components["schemas"]["Organisation"];
            partnerAccounts?: string[];
            softwareVendor?: components["schemas"]["SoftwareVendor"];
            type?: components["schemas"]["NetworkType"];
            /** Format: date-time */
            updatedAt?: string;
        };
        NetworkSummaryDto: {
            /** Format: uuid */
            networkId: string;
            networkName?: string;
        };
        /** @enum {string} */
        NetworkType: NetworkType;
        /**
         * @description Product offer from a specific merchant
         * @example []
         */
        OfferDto: {
            /**
             * @description Calculated commission for this offer based on shop's commission range
             * @example 45
             */
            commission?: number;
            /**
             * @description Price currency
             * @example EUR
             */
            currency: string;
            /**
             * Format: uuid
             * @description Feed identifier
             * @example 123e4567-e89b-12d3-a456-426614174003
             */
            feedId?: string;
            /**
             * @description Whether this product has variations (e.g., different sizes, colors)
             * @example true
             */
            hasVariations: boolean;
            /**
             * @description Product image URL
             * @example https://example.com/images/galaxy-s24.jpg
             */
            imageUrl?: string;
            /**
             * Format: uuid
             * @description Merchant identifier
             * @example 123e4567-e89b-12d3-a456-426614174002
             */
            merchantId: string;
            /**
             * @description Merchant name
             * @example My Sample Shop
             */
            merchantName: string;
            /**
             * Format: uuid
             * @description Unique offer identifier
             * @example 123e4567-e89b-12d3-a456-426614174000
             */
            offerId: string;
            /**
             * @description Product price
             * @example 899.99
             */
            price: number;
            /**
             * @description Old price before discount
             * @example 949.99
             */
            priceOld?: number;
            /**
             * @description Merchant-specific product name
             * @example Samsung Galaxy S24 128GB Phantom Black
             */
            productName: string;
            /**
             * Format: date-time
             * @description When the product was last updated
             * @example 2024-01-15T10:30:00Z
             */
            productUpdatedAt: string;
            /**
             * @description Recommended retail price
             * @example 999.99
             */
            recommendedRetailPrice: number;
            /**
             * @description Savings amount
             * @example 100
             */
            saving?: number;
            /**
             * @description Savings percentage
             * @example 10
             */
            savingsPercent?: number;
            shop?: components["schemas"]["ShopPlainDto"];
            /**
             * @description Store price
             * @example 899.99
             */
            storePrice: number;
            /**
             * @description Product target URL
             * @example https://shop.example.com/galaxy-s24
             */
            targetUrl: string;
        };
        Organisation: {
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            countryCode?: string;
            currencyCode?: string;
            description?: string;
            displayName?: string;
            /** Format: email */
            email?: string;
            legalForm?: components["schemas"]["LegalForm"];
            logoUrl?: string;
            name?: string;
            phoneNumber?: string;
            postalCode?: string;
            registrationNumber?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            state?: string;
            taxArea?: components["schemas"]["TaxArea"];
            taxLiable?: boolean;
            taxRegistrationNumber?: string;
            website?: string;
        };
        OrganisationTinyDto: {
            displayName?: string;
            name?: string;
        };
        /** @enum {string} */
        OverheadCostType: OverheadCostType;
        Pageable: {
            /** Format: int32 */
            page?: number;
            /** Format: int32 */
            size?: number;
            sort?: string[];
        };
        PageableObject: {
            /** Format: int64 */
            offset?: number;
            paged?: boolean;
            /** Format: int32 */
            pageNumber?: number;
            /** Format: int32 */
            pageSize?: number;
            sort?: components["schemas"]["SortObject"];
            unpaged?: boolean;
        };
        PagedModelEntityModelCharity: {
            content?: components["schemas"]["EntityModelCharity"][];
            links?: components["schemas"]["Link"][];
            page?: components["schemas"]["PageMetadata"];
        };
        PagedResponseAmazonDailyStatisticDto: {
            content: components["schemas"]["AmazonDailyStatisticDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseAmazonDailyStatisticPublicDto: {
            content: components["schemas"]["AmazonDailyStatisticPublicDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseCharityAdminListDto: {
            content: components["schemas"]["CharityAdminListDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseDiscountCodeDetailDto: {
            content: components["schemas"]["DiscountCodeDetailDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseDtoReleaseNoteListDto: {
            content?: components["schemas"]["ReleaseNoteListDto"][];
            hasNext?: boolean;
            hasPrevious?: boolean;
            /** Format: int32 */
            page?: number;
            /** Format: int32 */
            size?: number;
            /** Format: int64 */
            totalElements?: number;
            /** Format: int32 */
            totalPages?: number;
        };
        PagedResponseMerchantDto: {
            content: components["schemas"]["MerchantDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseProductSearchItemDto: {
            content: components["schemas"]["ProductSearchItemDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseProjectDetailedDto: {
            content: components["schemas"]["ProjectDetailedDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseProjectSupporterDto: {
            content: components["schemas"]["ProjectSupporterDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseShopDto: {
            content: components["schemas"]["ShopDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseShopPlainDto: {
            content: components["schemas"]["ShopPlainDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseTransactionDetailDto: {
            content: components["schemas"]["TransactionDetailDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseTransactionDto: {
            content: components["schemas"]["TransactionDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PagedResponseUserListDto: {
            content: components["schemas"]["UserListDto"][];
            /** Format: int32 */
            number: number;
            /** Format: int32 */
            size: number;
            /** Format: int64 */
            totalElements: number;
            /** Format: int32 */
            totalPages: number;
        };
        PageMetadata: {
            /** Format: int64 */
            number?: number;
            /** Format: int64 */
            size?: number;
            /** Format: int64 */
            totalElements?: number;
            /** Format: int64 */
            totalPages?: number;
        };
        PagePaymentDetailDto: {
            content?: components["schemas"]["PaymentDetailDto"][];
            empty?: boolean;
            first?: boolean;
            last?: boolean;
            /** Format: int32 */
            number?: number;
            /** Format: int32 */
            numberOfElements?: number;
            pageable?: components["schemas"]["PageableObject"];
            /** Format: int32 */
            size?: number;
            sort?: components["schemas"]["SortObject"];
            /** Format: int64 */
            totalElements?: number;
            /** Format: int32 */
            totalPages?: number;
        };
        PartnerAccount: {
            clientClass?: components["schemas"]["ClientClass"];
            contracts?: components["schemas"]["Contract"][];
            /** Format: date-time */
            createdAt?: string;
            credentialsSecret?: string;
            credentialsUser?: string;
            displayName?: string;
            externalAccountId?: string;
            externalSubAccountId?: string;
            /** Format: uuid */
            id: string;
            merchantApiBaseUrl?: string;
            merchantClickProductUrl?: string;
            merchantClickUrl?: string;
            merchantFeedApiBaseUrl?: string;
            /** Format: int32 */
            merchantFeedImportIntervalSeconds: number;
            /** Format: int32 */
            merchantImportIntervalSeconds: number;
            network: components["schemas"]["Network"];
            tansactionApiBaseUrl?: string;
            /** Format: int32 */
            transactionImportIntervalLengthSeconds: number;
            /** Format: int32 */
            transactionImportIntervalSeconds: number;
            /** Format: date-time */
            transactionImportStartAt?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @enum {string} */
        PaymentConsistencyStatus: PaymentConsistencyStatus;
        PaymentDetailDto: {
            amountGross?: number;
            amountNet?: number;
            amountTax?: number;
            bankAccountInfo?: {
                [key: string]: Record<string, never>;
            };
            consistencyStatus?: components["schemas"]["PaymentConsistencyStatus"];
            /** Format: date-time */
            createdAt?: string;
            creditNote?: string;
            currency?: string;
            currencyRate?: number;
            current?: boolean;
            /** Format: date */
            disbursementDate?: string;
            externalPaymentId?: string;
            hasCreditNote?: boolean;
            hasTransactionList?: boolean;
            /** Format: uuid */
            id?: string;
            /** Format: int32 */
            matchedTransactionCount?: number;
            missingTransactionExternalIds?: string[];
            /** Format: uuid */
            networkId?: string;
            networkName?: string;
            /** Format: date */
            periodEnd?: string;
            /** Format: date */
            periodStart?: string;
            positions?: {
                [key: string]: Record<string, never>;
            }[];
            status?: components["schemas"]["PaymentStatus"];
            /** Format: int32 */
            transactionCount?: number;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @enum {string} */
        PaymentStatus: PaymentStatus;
        PersonalDetails: {
            address?: components["schemas"]["Address"];
            /** Format: date */
            dateOfBirth?: string;
            /** Format: email */
            email?: string;
            firstName?: string;
            gender?: components["schemas"]["Gender"];
            lastName?: string;
            phoneNumber?: string;
            profilePictureUrl?: string;
        };
        /** @enum {string} */
        ProcessedStatus: ProcessedStatus;
        Product: {
            /** Format: date-time */
            createdAt?: string;
            description?: string;
            ean?: string;
            gtin?: string;
            /** Format: uuid */
            id: string;
            imageUrl?: string;
            isbn?: string;
            merchantProductId?: string;
            mmn?: string;
            mpn?: string;
            name: string;
            offers?: components["schemas"]["ProductOffer"][];
            parentProductId?: string;
            upc?: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        ProductOffer: {
            category?: components["schemas"]["Category"];
            /** Format: date-time */
            createdAt?: string;
            externalProductId: string;
            feed?: components["schemas"]["MerchantFeed"];
            hasVariations: boolean;
            matchUsedColumn?: components["schemas"]["MatchUsedColumn"];
            merchant: components["schemas"]["Merchant"];
            /** Format: uuid */
            offerId: string;
            price: number;
            priceOld?: number;
            product: components["schemas"]["Product"];
            productName: string;
            /** Format: date-time */
            productUpdatedAt: string;
            recommendedRetailPrice: number;
            saving?: number;
            savingsPercent?: number;
            storePrice: number;
            targetUrl: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        /** @description Product search result item with canonical product information and merchant offers */
        ProductSearchItemDto: {
            /**
             * Format: date-time
             * @description When the product was created
             * @example 2024-01-15T10:30:00Z
             */
            createdAt: string;
            /** @description Product description */
            description?: string;
            /**
             * @description European Article Number
             * @example 1234567890123
             */
            ean?: string;
            /**
             * @description Global Trade Item Number
             * @example 1234567890123
             */
            gtin?: string;
            /**
             * @description Product image URL
             * @example https://example.com/images/product.jpg
             */
            imageUrl?: string;
            /**
             * @description International Standard Book Number
             * @example 9781234567890
             */
            isbn?: string;
            /**
             * @description Manufacturer Model Number
             * @example Galaxy-S24
             */
            mmn?: string;
            /**
             * @description Manufacturer Part Number
             * @example SM-S921B
             */
            mpn?: string;
            /**
             * @description Canonical product name
             * @example Samsung Galaxy S24
             */
            name: string;
            /**
             * @description List of merchant offers for this product
             * @example []
             */
            offers: components["schemas"]["OfferDto"][];
            /**
             * Format: uuid
             * @description Unique product identifier
             * @example 123e4567-e89b-12d3-a456-426614174000
             */
            productId: string;
            /**
             * @description Universal Product Code
             * @example 123456789012
             */
            upc?: string;
            /**
             * Format: date-time
             * @description When the product was last updated
             * @example 2024-01-20T15:45:00Z
             */
            updatedAt: string;
        };
        ProjectAdminDto: {
            addressLine1?: string;
            addressLine2?: string;
            /** Format: uuid */
            charityId: string;
            city?: string;
            countryCode?: string;
            /** Format: date-time */
            createdAt?: string;
            description?: string;
            email?: string;
            /** Format: date */
            endDate?: string;
            fieldsOfWork: components["schemas"]["FieldOfWorkDto"][];
            focusedCountryCodes?: string[];
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
            phoneNumber?: string;
            postalCode?: string;
            slug: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            /** Format: date */
            startDate?: string;
            state?: string;
            status: components["schemas"]["ProjectStatus"];
            /** Format: date-time */
            updatedAt?: string;
            website?: string;
        };
        ProjectDetailedDto: {
            addressLine1?: string;
            addressLine2?: string;
            canonicalSlug?: string;
            charity: components["schemas"]["CharityDto"];
            city?: string;
            countryCode?: string;
            description: string;
            email?: string;
            /** Format: date */
            endDate?: string;
            fieldsOfWork?: components["schemas"]["FieldOfWorkDto"][];
            focusedCountryCodes?: string[];
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
            phoneNumber?: string;
            postalCode?: string;
            slug: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            /** Format: date */
            startDate?: string;
            state?: string;
            status: components["schemas"]["ProjectStatus"];
            /** Format: date-time */
            updatedAt?: string;
            website?: string;
        };
        ProjectDto: {
            canonicalSlug?: string;
            description?: string;
            /** Format: uuid */
            id: string;
            logoUrl?: string;
            name: string;
            slug: string;
            status: components["schemas"]["ProjectStatus"];
            /** Format: date-time */
            updatedAt?: string;
        };
        ProjectStatisticsDto: {
            /** Format: int64 */
            supporterCount?: number;
            totalDonations?: number;
        };
        /** @enum {string} */
        ProjectStatus: ProjectStatus;
        ProjectSupporterDto: {
            firstName?: string;
            /** Format: uuid */
            id?: string;
            profilePictureUrl?: string;
        };
        PurchasedVoucherDto: {
            amount?: number;
            /** Format: date-time */
            createdAt?: string;
            currency?: string;
            /** Format: uuid */
            id?: string;
            shopId?: string;
            status?: components["schemas"]["VoucherPurchaseStatus"];
            voucherCode?: string;
        };
        /** @enum {string} */
        ReleaseNoteCategory: ReleaseNoteCategory;
        ReleaseNoteDetailDto: {
            aiModel?: string;
            /** Format: date-time */
            aiProcessedAt?: string;
            /** Format: int32 */
            aiTotalTokens?: number;
            category: components["schemas"]["ReleaseNoteCategory"];
            content: string;
            images?: components["schemas"]["ReleaseNoteImage"][];
            /** Format: int32 */
            importance: number;
            /** Format: date-time */
            prCreatedAt?: string;
            /** Format: int64 */
            prId: number;
            /** Format: date-time */
            prMergedAt?: string;
            prStatus?: string;
            /** Format: date-time */
            publishedAt?: string;
            relatedLinks?: components["schemas"]["ReleaseNoteLink"][];
            slug: string;
            summary: string;
            title: string;
        };
        ReleaseNoteImage: {
            alt?: string;
            caption?: string;
            main?: boolean;
            url?: string;
        };
        ReleaseNoteLink: {
            description?: string;
            icon?: string;
            title?: string;
            url?: string;
        };
        ReleaseNoteListDto: {
            category: components["schemas"]["ReleaseNoteCategory"];
            /** Format: int32 */
            importance: number;
            /** Format: int64 */
            prId: number;
            /** Format: date-time */
            prMergedAt?: string;
            /** Format: date-time */
            publishedAt?: string;
            slug: string;
            summary: string;
            title: string;
        };
        RepresentationModelObject: {
            links?: components["schemas"]["Link"][];
        };
        RuleCondition: {
            conditionType?: components["schemas"]["ConditionType"];
            conditionValue?: string;
            customKey?: string;
        };
        SetShopRequest: {
            /** Format: uuid */
            shopId?: string;
        };
        Shop: {
            categories: components["schemas"]["Category"][];
            /** Format: date-time */
            createdAt?: string;
            description: string;
            domainName: string;
            /** Format: uuid */
            id: string;
            internalNotes?: string;
            logoUrl: string;
            merchants: components["schemas"]["Merchant"][];
            monetized?: boolean;
            name: string;
            /** Format: double */
            popularityScore: number;
            slug: string;
            status: components["schemas"]["ShopStatus"];
            /** Format: date-time */
            updatedAt?: string;
            websiteUrl: string;
        };
        ShopDto: {
            canonicalSlug?: string;
            categories: components["schemas"]["CategoryDto"][];
            commissionRangeSummary?: components["schemas"]["CommissionRangeSummary"];
            contractType?: components["schemas"]["ContractType"];
            /** Format: date-time */
            createdAt?: string;
            description: string;
            /** Format: uuid */
            id: string;
            internalNotes?: string;
            logoUrl: string;
            merchants: components["schemas"]["MerchantDto"][];
            monetized: boolean;
            name: string;
            popular: boolean;
            slug: string;
            status: components["schemas"]["ShopStatus"];
            /** Format: date-time */
            updatedAt?: string;
            websiteUrl: string;
        };
        ShopExtensionConfigDto: {
            discountCodesEnabled?: boolean;
            recentTransactionsEnabled?: boolean;
            reminderEnabled?: boolean;
            serpAnnotationEnabled?: boolean;
        };
        /** @description Shop information including name, logo, and commission details */
        ShopPlainDto: {
            canonicalSlug?: string;
            commissionRangeSummary?: components["schemas"]["CommissionRangeSummary"];
            /** Format: uuid */
            id: string;
            logoUrl: string;
            name: string;
            slug: string;
            websiteUrl: string;
        };
        /** @enum {string} */
        ShopStatus: ShopStatus;
        SlugPreviewRequest: {
            name: string;
        };
        SlugPreviewResponse: {
            slug: string;
        };
        SlugValidateRequest: {
            slug: string;
        };
        SlugValidateResponse: {
            available: boolean;
            reason?: string;
            valid: boolean;
        };
        SocialMedia: {
            platform?: components["schemas"]["SocialMediaPlatform"];
            url?: string;
        };
        /** @enum {string} */
        SocialMediaPlatform: SocialMediaPlatform;
        /** @enum {string} */
        SoftwareVendor: SoftwareVendor;
        SortObject: {
            empty?: boolean;
            sorted?: boolean;
            unsorted?: boolean;
        };
        StatusUpdateRequest: {
            status: string;
        };
        TaxArea: {
            code: string;
            /** Format: date-time */
            createdAt?: string;
            displayName: string;
            /** Format: uuid */
            id: string;
            taxType: string;
            /** Format: date-time */
            updatedAt?: string;
        };
        Transaction: {
            amendReason?: string;
            basketData?: components["schemas"]["BasketData"];
            click?: components["schemas"]["Click"];
            commissionAmount: number;
            commissionCurrency: string;
            /** Format: date-time */
            createdAt: string;
            current: boolean;
            declineReason?: string;
            discountCode?: string;
            discountCodeUsed?: boolean;
            externalId: string;
            externalPaymentId?: string;
            feeAmount: number;
            /** Format: uuid */
            feeRuleId: string;
            grossCommissionAmount: number;
            /** Format: uuid */
            id: string;
            merchant: components["schemas"]["Merchant"];
            originalCommissionAmount: number;
            originalCommissionCurrency: string;
            originalCommissionCurrencyRate: number;
            originalPriceAmount: number;
            originalPriceCurrency: string;
            originalPriceCurrencyRate: number;
            /** Format: uuid */
            paymentId?: string;
            priceAmount: number;
            priceCurrency: string;
            status: components["schemas"]["TransactionStatus"];
            subId?: string;
            /** Format: date-time */
            updatedAt: string;
            userFacing: boolean;
        };
        TransactionDetailDto: {
            amendReason?: string;
            clampApplied: boolean;
            clickClientClass?: string;
            clickClientVersion?: string;
            /** Format: date-time */
            clickCreatedAt?: string;
            /** Format: int64 */
            clickId?: number;
            clickPageUrl?: string;
            commissionAmount: number;
            commissionCurrency: string;
            contractType?: components["schemas"]["ContractType"];
            /** Format: date-time */
            createdAt: string;
            current: boolean;
            declineReason?: string;
            discountCode?: string;
            discountCodeUsed?: boolean;
            emailSentStatus?: components["schemas"]["EmailSentStatus"];
            externalId: string;
            externalPaymentId?: string;
            feeAmount: number;
            feeRuleName: string;
            feeScheduleName: string;
            grossCommissionAmount: number;
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            merchantId: string;
            merchantName: string;
            /** Format: uuid */
            networkId: string;
            networkName?: string;
            /** Format: uuid */
            paymentId?: string;
            priceAmount: number;
            priceCurrency: string;
            /** Format: uuid */
            projectId?: string;
            projectLogoUrl?: string;
            projectName?: string;
            projectSlug?: string;
            /** Format: uuid */
            shopId?: string;
            shopName?: string;
            status: components["schemas"]["TransactionStatus"];
            subId?: string;
            /** Format: date-time */
            updatedAt: string;
            userAnonymous?: boolean;
            userEmail?: string;
            userFacing: boolean;
            userFirstName?: string;
            /** Format: uuid */
            userId?: string;
            userLastName?: string;
        };
        TransactionDetailPublicDto: {
            commissionAmount: number;
            commissionCurrency: string;
            /** Format: date-time */
            createdAt: string;
            declineReason?: string;
            history: components["schemas"]["TransactionVersionEntry"][];
            /** Format: uuid */
            id: string;
            priceAmount: number;
            priceCurrency: string;
            /** Format: uuid */
            projectId?: string;
            projectLogoUrl?: string;
            projectName?: string;
            projectSlug?: string;
            /** Format: uuid */
            shopId?: string;
            shopLogoUrl?: string;
            shopName: string;
            shopSlug?: string;
            status: components["schemas"]["TransactionStatus"];
        };
        TransactionDto: {
            commissionAmount: number;
            currency: string;
            /** Format: uuid */
            id: string;
            priceAmount: number;
            /** Format: uuid */
            projectId?: string;
            projectLogoUrl?: string;
            projectName?: string;
            projectSlug?: string;
            /** Format: uuid */
            shopId?: string;
            shopLogoUrl?: string;
            shopName: string;
            shopSlug?: string;
            status: components["schemas"]["TransactionStatus"];
            /** Format: date-time */
            transactionTime: string;
            user?: components["schemas"]["UserSummaryDto"];
        };
        TransactionMetricsDto: {
            byNetwork: components["schemas"]["TransactionNetworkMetrics"][];
            byShop: components["schemas"]["TransactionShopMetrics"][];
            byStatus: components["schemas"]["TransactionStatusMetrics"][];
            pendingResolution: components["schemas"]["TransactionPendingResolutionRow"][];
            totalCommissionEur: number;
            /** Format: int64 */
            totalCount: number;
            totalPriceEur: number;
            /** Format: int64 */
            totalUserFacingCount: number;
        };
        TransactionNetworkMetrics: {
            /** Format: int64 */
            count: number;
            /** Format: uuid */
            networkId: string;
            networkName?: string;
            totalCommissionEur: number;
            totalPriceEur: number;
        };
        TransactionPendingResolutionRow: {
            /** Format: double */
            avgSeconds: number;
            /** Format: uuid */
            networkId: string;
            networkName?: string;
            resolvedStatus: components["schemas"]["TransactionStatus"];
            /** Format: int64 */
            sampleCount: number;
        };
        TransactionShopMetrics: {
            /** Format: int64 */
            count: number;
            /** Format: uuid */
            shopId?: string;
            shopName: string;
            totalCommissionEur: number;
            totalPriceEur: number;
        };
        /** @enum {string} */
        TransactionStatus: TransactionStatus;
        TransactionStatusMetrics: {
            /** Format: int64 */
            count: number;
            status: components["schemas"]["TransactionStatus"];
            totalCommissionEur: number;
            totalPriceEur: number;
        };
        TransactionVersionEntry: {
            commissionAmount: number;
            declineReason?: string;
            status: components["schemas"]["TransactionStatus"];
            /** Format: date-time */
            timestamp: string;
        };
        UpdateCategoryRequest: {
            color?: string;
            icon?: string;
            name?: string;
        };
        UpdateCharityRequest: {
            addressLine1?: string;
            addressLine2?: string;
            certificateGrants?: components["schemas"]["CertificateGrantInputDto"][];
            city?: string;
            countryCode?: string;
            currencyCode?: string;
            description?: string;
            displayName?: string;
            email?: string;
            /** Format: int32 */
            employees?: number;
            fieldOfWorkIds?: string[];
            focusedCountryCodes?: string[];
            /** Format: date */
            founded?: string;
            fundraisingIncome?: number;
            governingBody?: string;
            legalForm?: string;
            logoUrl?: string;
            name?: string;
            phoneNumber?: string;
            postalCode?: string;
            registrationNumber?: string;
            reportingYear?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            state?: string;
            taxDeductible?: boolean;
            taxLiable?: boolean;
            taxRegistrationNumber?: string;
            totalExpenses?: number;
            totalIncome?: number;
            /** Format: int32 */
            volunteers?: number;
            /** Format: int32 */
            votingMembers?: number;
            website?: string;
            worldview?: string;
        };
        UpdateDiscountCodeStatusRequest: {
            status?: components["schemas"]["DiscountCodeStatus"];
        };
        UpdatedShopDto: {
            /** Format: int32 */
            activeDiscountCodeCount?: number;
            canonicalSlug?: string;
            commissionRangeSummary?: components["schemas"]["CommissionRangeSummary"];
            domainName?: string;
            extensionConfig?: {
                [key: string]: components["schemas"]["ShopExtensionConfigDto"];
            };
            /** Format: uuid */
            id?: string;
            logoUrl?: string;
            name?: string;
            slug?: string;
            status?: components["schemas"]["ShopStatus"];
        };
        UpdatedShopsResponse: {
            /** Format: date-time */
            lastUpdatedAt?: string;
            shops?: components["schemas"]["UpdatedShopDto"][];
        };
        UpdateMerchantRequest: {
            categories?: string[];
            currencyCode?: string;
            description?: string;
            email?: string;
            externalId?: string;
            name?: string;
            regionCountryCodes?: string[];
            status?: components["schemas"]["MerchantStatus"];
            websiteUrl?: string;
        };
        UpdateProjectRequest: {
            addressLine1?: string;
            addressLine2?: string;
            city?: string;
            countryCode?: string;
            description?: string;
            email?: string;
            /** Format: date */
            endDate?: string;
            fieldOfWorkIds?: string[];
            focusedCountryCodes?: string[];
            name?: string;
            phoneNumber?: string;
            postalCode?: string;
            slug?: string;
            socialMedia?: components["schemas"]["SocialMedia"][];
            /** Format: date */
            startDate?: string;
            state?: string;
            website?: string;
        };
        UpdateShopAdminRequest: {
            categories?: string[];
            description?: string;
            internalNotes?: string;
            logoUrl?: string;
            merchants?: string[];
            name?: string;
            /** Format: double */
            popularityScore?: number;
            slug?: string;
            status?: components["schemas"]["ShopStatus"];
            websiteUrl?: string;
        };
        UploadDocumentResponse: {
            publicUrl?: string;
        };
        /** @description The URL of the uploaded shop logo */
        UploadLogoResponse: {
            /**
             * @description Publicly accessible URL for the shop’s logo
             * @example https://cdn.example.com/shops/123/logo.png
             */
            publicUrl: string;
        };
        /** @description Response for profile picture upload */
        UploadProfilePictureResponse: {
            /**
             * @description Error message if the upload failed. Null if upload succeeded.
             * @example File size exceeds 5 MB limit
             */
            error?: string;
            /**
             * @description Publicly accessible URL for the user's profile picture. Null if upload failed.
             * @example https://storage.googleapis.com/donista-be-public-images-9jf6de6vxv/user/profile-picture/123e4567-e89b-12d3-a456-426614174000.jpg
             */
            publicUrl?: string;
        };
        UpsertMappingRequest: {
            /** Format: uuid */
            categoryId: string;
            externalCategoryName: string;
            /** Format: uuid */
            networkId: string;
        };
        UserAdminDetailDto: {
            addressLine1?: string;
            addressLine2?: string;
            anonymous: boolean;
            city?: string;
            countryCode?: string;
            /** Format: date-time */
            createdAt: string;
            customClaims?: components["schemas"]["CustomClaim"][];
            /** Format: date */
            dateOfBirth?: string;
            email?: string;
            emailVerified: boolean;
            firebaseUid: string;
            firstName?: string;
            gender?: components["schemas"]["Gender"];
            /** Format: uuid */
            id: string;
            identityProviders?: string[];
            /** Format: date-time */
            lastLoginAt: string;
            lastName?: string;
            phoneNumber?: string;
            postalCode?: string;
            profilePictureUrl?: string;
            /** Format: int64 */
            referredUsersCount: number;
            /** Format: uuid */
            referrerUserId?: string;
            referrerUserName?: string;
            /** Format: uuid */
            selectedProjectId?: string;
            selectedProjectName?: string;
            status: components["schemas"]["UserStatus"];
            /** Format: date-time */
            updatedAt: string;
        };
        UserDonationSummaryDto: {
            currency?: string;
            deletedAmount?: number;
            deniedAmount?: number;
            paidAmount?: number;
            pendingAmount?: number;
            receivedAmount?: number;
            totalAmount?: number;
            validatedAmount?: number;
        };
        UserDTO: {
            anonymous?: boolean;
            /** Format: date-time */
            createdAt?: string;
            customClaims?: components["schemas"]["CustomClaim"][];
            emailVerified?: boolean;
            firebaseUid?: string;
            /** Format: uuid */
            id: string;
            identityProviders?: components["schemas"]["IdentityProvider"][];
            /** Format: date-time */
            lastLoginAt?: string;
            newUser?: boolean;
            personalDetails?: components["schemas"]["PersonalDetails"];
            referrerUser?: components["schemas"]["UserDTO"];
            selectedProject?: components["schemas"]["ProjectDetailedDto"];
            settings?: {
                [key: string]: string;
            };
            /** Format: date-time */
            updatedAt?: string;
        };
        UserListDto: {
            anonymous?: boolean;
            /** Format: date-time */
            createdAt?: string;
            customClaims?: components["schemas"]["CustomClaim"][];
            email?: string;
            emailVerified?: boolean;
            firstName?: string;
            /** Format: uuid */
            id: string;
            identityProviders?: string[];
            /** Format: date-time */
            lastLoginAt?: string;
            lastName?: string;
            profilePictureUrl?: string;
            status: components["schemas"]["UserStatus"];
            /** Format: date-time */
            updatedAt?: string;
        };
        UserStatsDto: {
            /** Format: int64 */
            anonymousCount: number;
            /** Format: int64 */
            emailVerifiedCount: number;
            timeSeries: components["schemas"]["UserTimeSeriesEntryDto"][];
            /** Format: int64 */
            totalCount: number;
        };
        /** @enum {string} */
        UserStatus: UserStatus;
        UserSummaryDto: {
            firstName?: string;
            profilePictureUrl?: string;
            status: components["schemas"]["UserStatus"];
        };
        UserTimeSeriesEntryDto: {
            /** Format: int64 */
            activeAnonymous: number;
            /** Format: int64 */
            activeCount: number;
            /** Format: int64 */
            activeNonAnonymous: number;
            date: string;
            /** Format: double */
            growthRateAnonymous?: number;
            /** Format: double */
            growthRateNonAnonymous?: number;
            /** Format: double */
            growthRateTotal?: number;
            /** Format: int64 */
            newAnonymous: number;
            /** Format: int64 */
            newNonAnonymous: number;
            /** Format: int64 */
            newTotal: number;
            /** Format: int64 */
            runningAnonymous: number;
            /** Format: int64 */
            runningNonAnonymous: number;
            /** Format: int64 */
            runningTotal: number;
        };
        VoucherPaymentIntentRequest: {
            /** Format: double */
            amount?: number;
            shopId: string;
        };
        VoucherPaymentIntentResponse: {
            clientSecret?: string;
        };
        /** @enum {string} */
        VoucherPurchaseStatus: VoucherPurchaseStatus;
        WishlistBatchCheckRequest: {
            productIds?: string[];
        };
        WishlistBatchCheckResponse: {
            results?: {
                [key: string]: boolean;
            };
        };
        WishlistCheckResponse: {
            wishlisted?: boolean;
        };
        WishlistCountResponse: {
            /** Format: int64 */
            count?: number;
        };
        /** @enum {string} */
        Worldview: Worldview;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    getAllStatistics: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseAmazonDailyStatisticDto"];
                };
            };
        };
    };
    getDaily: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseAmazonDailyStatisticPublicDto"];
                };
            };
        };
    };
    getSummary: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["AmazonStatisticsSummaryDto"];
                };
            };
        };
    };
    checkForUpdate: {
        parameters: {
            query: {
                /**
                 * @description Platform (ANDROID or IOS)
                 * @example ANDROID
                 */
                platform: components["schemas"]["AppPlatform"];
                /**
                 * @description Client's current version
                 * @example 1.3.0
                 */
                version: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Update check completed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["AppUpdateCheckResponse"];
                };
            };
            /** @description Invalid request parameters (missing or invalid platform/version) */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["AppUpdateCheckResponse"];
                };
            };
        };
    };
    createCategory: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCategoryRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryAdminTreeDto"];
                };
            };
        };
    };
    "getItemResource-category-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelCategory"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    deleteCategory: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateCategory: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCategoryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryAdminTreeDto"];
                };
            };
        };
    };
    getAssignedShops: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryAssignedShopsDto"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryAssignedShopsDto"];
                };
            };
        };
    };
    deassignShops: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelCategory"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelCategory"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get_2": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelShop"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get_3": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelShop"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    assignShop: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    unassignShop: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Category ID */
                id: string;
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get_4": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelCategory"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-category-get_5": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelCategory"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getMainCategoriesWithCounts: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoriesWithTotalCountDto"];
                };
            };
        };
    };
    getTree: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryTreeDto"][];
                };
            };
        };
    };
    getAdminTree: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryAdminTreeDto"][];
                };
            };
        };
    };
    listCharities: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Optional search term to filter charities by name */
                searchTerm?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional status filter */
                status?: components["schemas"]["CharityStatus"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseCharityAdminListDto"];
                };
            };
        };
    };
    createCharity: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateCharityRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CharityAdminDetailDto"];
                };
            };
        };
    };
    deleteCertificateGrantDocument: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Certificate grant ID */
                grantId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    uploadCertificateGrantDocument: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Certificate grant ID */
                grantId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description PDF document file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadDocumentResponse"];
                };
            };
        };
    };
    listProjects: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectAdminDto"][];
                };
            };
        };
    };
    createProject: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateProjectRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectAdminDto"];
                };
            };
        };
    };
    updateProject: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Project ID */
                projectId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateProjectRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectAdminDto"];
                };
            };
        };
    };
    deleteProjectLogo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Project ID */
                projectId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateProjectStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Project ID */
                projectId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["StatusUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectAdminDto"];
                };
            };
        };
    };
    uploadProjectLogo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                charityId: string;
                /** @description Project ID */
                projectId: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Logo image file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadLogoResponse"];
                };
            };
        };
    };
    updateCharity: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateCharityRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CharityAdminDetailDto"];
                };
            };
        };
    };
    getCharity: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CharityAdminDetailDto"];
                };
            };
        };
    };
    ejectFromDzi: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CharityAdminDetailDto"];
                };
            };
        };
    };
    updateCharityStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["StatusUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CharityAdminDetailDto"];
                };
            };
        };
    };
    uploadLogo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Charity ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Logo image file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadLogoResponse"];
                };
            };
        };
    };
    getCertificates: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CertificateAdminDto"][];
                };
            };
        };
    };
    getFieldsOfWork: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FieldOfWorkDto"][];
                };
            };
        };
    };
    "executeSearch-charity-get": {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedModelEntityModelCharity"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getClick: {
        parameters: {
            query: {
                clickRequest: components["schemas"]["ClickRequest"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["Click"];
                };
            };
        };
    };
    listDiscountCodes: {
        parameters: {
            query?: {
                /** @description Filter by shop category ID */
                categoryId?: string;
                /** @description Filter by created_at from */
                createdAtFrom?: string;
                /** @description Filter by created_at to */
                createdAtTo?: string;
                /** @description Filter by ends_at from */
                endsAtFrom?: string;
                /** @description Filter by ends_at to */
                endsAtTo?: string;
                /** @description Filter by network ID */
                networkId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Search by title or code */
                search?: string;
                /** @description Filter by shop ID */
                shopId?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Filter by starts_at from */
                startsAtFrom?: string;
                /** @description Filter by starts_at to */
                startsAtTo?: string;
                /** @description Filter by status */
                status?: components["schemas"]["DiscountCodeStatus"];
                /** @description Filter by updated_at from */
                updatedAtFrom?: string;
                /** @description Filter by updated_at to */
                updatedAtTo?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseDiscountCodeDetailDto"];
                };
            };
        };
    };
    getDiscountCodeById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Discount code ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeDetailDto"];
                };
            };
            /** @description Discount code not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeDetailDto"];
                };
            };
        };
    };
    updateDiscountCodeStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Discount code ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateDiscountCodeStatusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeDetailDto"];
                };
            };
            /** @description Discount code not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeDetailDto"];
                };
            };
        };
    };
    getByShop: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeDto"][];
                };
            };
        };
    };
    getLatestDiscountCodes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["LatestDiscountCodeDto"][];
                };
            };
        };
    };
    checkShopsActiveDiscountCodes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DiscountCodeShopBatchCheckRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeShopBatchCheckResponse"];
                };
            };
            /** @description Too many shop IDs */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["DiscountCodeShopBatchCheckResponse"];
                };
            };
        };
    };
    getFavourites: {
        parameters: {
            query?: {
                /** @description Page number (0-indexed) */
                page?: number;
                /** @description Page size */
                size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Favourite shops retrieved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopPlainDto"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopPlainDto"];
                };
            };
        };
    };
    addToFavourites: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Shop added to favourites */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    removeFromFavourites: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Shop removed from favourites */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    checkBatchFavourited: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FavouriteShopBatchCheckRequest"];
            };
        };
        responses: {
            /** @description Batch check result */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopBatchCheckResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopBatchCheckResponse"];
                };
            };
        };
    };
    checkFavourited: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                shopId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Check result */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopCheckResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopCheckResponse"];
                };
            };
        };
    };
    getFavouritesCount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Count retrieved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopCountResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FavouriteShopCountResponse"];
                };
            };
        };
    };
    listSchedules: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"][];
                };
            };
        };
    };
    publish: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FeeScheduleAdminCreateRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"];
                };
            };
            /** @description Validation failed */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"];
                };
            };
            /** @description Window contains existing transactions */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"];
                };
            };
        };
    };
    getSchedule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Fee schedule ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeScheduleAdminDto"];
                };
            };
        };
    };
    expire: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Fee schedule ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Schedule already active or not found */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Schedule has a successor */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    preview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FeeSchedulePreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": Record<string, never>;
                };
            };
        };
    };
    getPreviewJobStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Preview job ID */
                jobId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeSchedulePreviewJobStatusResponse"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FeeSchedulePreviewJobStatusResponse"];
                };
            };
        };
    };
    createBulk: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FieldOfWork"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FieldOfWork"][];
                };
            };
        };
    };
    getAll: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["FieldOfWorkDto"][];
                };
            };
        };
    };
    getLogoPlaces: {
        parameters: {
            query: {
                /** @description Stop after finding 5 high-confidence candidates (score ≥ 0.7) */
                stopEarly?: boolean;
                /** @description URL to look up logo placements for */
                url: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["LogoResponse"][];
                };
            };
        };
    };
    downloadLogo: {
        parameters: {
            query: {
                /** @description Absolute URL of the image to download */
                url: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
        };
    };
    getAllMerchants: {
        parameters: {
            query?: {
                /** @description Optional contract statuses to filter by (multi-select) */
                contractStatuses?: components["schemas"]["ContractStatus"][];
                /** @description Optional filter for whether a shop is assigned */
                hasShop?: boolean;
                /** @description Optional merchant statuses to filter by (multi-select) */
                merchantStatuses?: components["schemas"]["MerchantStatus"][];
                /** @description Optional network ID to filter by */
                networkId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Optional region country codes to filter by (multi-select) */
                regions?: string[];
                /** @description Optional shop website URL to filter merchants by domain */
                shopWebsiteUrl?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional search term to filter merchants by name */
                term?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseMerchantDto"];
                };
            };
        };
    };
    createMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateMerchantRequest"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MerchantDto"];
                };
            };
        };
    };
    "getItemResource-merchant-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelMerchant"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    updateMerchant: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Merchant ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMerchantRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MerchantDto"];
                };
            };
        };
    };
    "followPropertyReference-merchant-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelContract"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-merchant-get_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelContract"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-merchant-get_2": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-merchant-get_3": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-merchant-get_4": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelShop"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    setMerchantShop: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Merchant ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetShopRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MerchantDto"];
                };
            };
        };
    };
    "followPropertyReference-merchant-get_5": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelShop"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getMerchantById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Merchant ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MerchantDto"];
                };
            };
        };
    };
    getMerchantsByDomain: {
        parameters: {
            query: {
                /** @description URL to match merchants by domain */
                url: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MerchantDto"][];
                };
            };
        };
    };
    upsertMapping: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpsertMappingRequest"];
            };
        };
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    deleteMapping: {
        parameters: {
            query: {
                /** @description External merchant category name */
                externalCategoryName: string;
                /** @description Network ID */
                networkId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getMappingsByCategory: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CategoryMappingRowDto"][];
                };
            };
        };
    };
    getMappingsByNetwork: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Network ID */
                networkId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ExternalCategoryMappingRowDto"][];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ExternalCategoryMappingRowDto"][];
                };
            };
        };
    };
    getExternalCategoriesForNetwork: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Network ID */
                networkId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string[];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string[];
                };
            };
        };
    };
    getOverview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["NetworkMappingOverviewDto"][];
                };
            };
        };
    };
    getAllNetworks: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["NetworkSummaryDto"][];
                };
            };
        };
    };
    "postCollectionResource-network-post": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NetworkRequestBody"];
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                };
            };
        };
    };
    "putItemResource-network-put": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NetworkRequestBody"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                };
            };
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "patchItemResource-network-patch": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NetworkRequestBody"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelNetwork"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "createPropertyReference-network-put": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollectionModelObject"];
                "application/x-spring-data-compact+json": components["schemas"]["CollectionModelObject"];
                "text/uri-list": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelMerchant"];
                };
            };
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelMerchant"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "createPropertyReference-network-patch": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollectionModelObject"];
                "application/x-spring-data-compact+json": components["schemas"]["CollectionModelObject"];
                "text/uri-list": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelMerchant"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "createPropertyReference-network-put_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollectionModelObject"];
                "application/x-spring-data-compact+json": components["schemas"]["CollectionModelObject"];
                "text/uri-list": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelPartnerAccount"];
                };
            };
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelPartnerAccount"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "createPropertyReference-network-patch_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CollectionModelObject"];
                "application/x-spring-data-compact+json": components["schemas"]["CollectionModelObject"];
                "text/uri-list": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelPartnerAccount"];
                };
            };
            /** @description No Content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    listPayments: {
        parameters: {
            query?: {
                /** @description Filter by consistency status */
                consistencyStatus?: components["schemas"]["PaymentConsistencyStatus"];
                /** @description Filter by disbursement date from */
                disbursementDateFrom?: string;
                /** @description Filter by disbursement date to */
                disbursementDateTo?: string;
                /** @description Filter by network ID */
                networkId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagePaymentDetailDto"];
                };
            };
        };
    };
    getPaymentDetail: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Payment ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PaymentDetailDto"];
                };
            };
        };
    };
    downloadFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description File type to download */
                fileType: components["schemas"]["FileType"];
                /** @description Payment ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description File downloaded successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
            /** @description Payment or file not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                };
            };
        };
    };
    getPaymentHistory: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Payment ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PaymentDetailDto"][];
                };
            };
        };
    };
    revalidateConsistency: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Payment ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Payment revalidated successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PaymentDetailDto"];
                };
            };
            /** @description Payment not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PaymentDetailDto"];
                };
            };
        };
    };
    ping: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Service is up */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ping_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Service is up */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    findById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Product ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Product found */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProductSearchItemDto"];
                };
            };
            /** @description Product not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProductSearchItemDto"];
                };
            };
        };
    };
    searchProducts: {
        parameters: {
            query: {
                /**
                 * @description Barcode type hint for barcode searches (e.g. 'ean13', 'ean8', 'upc_a', 'upc_e', 'code128', 'code39', 'qr')
                 * @example ean13
                 */
                barcodeType?: string;
                /** @description Client class for platform-aware Amazon partner tag selection */
                cc?: components["schemas"]["ClientClass"];
                /**
                 * @description Return diagnostic timing headers
                 * @example false
                 */
                debug?: boolean;
                /**
                 * @description Also return EXPLAIN ANALYZE plan for dominant stage
                 * @example false
                 */
                explain?: boolean;
                /**
                 * @description Page number (0-based)
                 * @example 0
                 */
                page?: number;
                /**
                 * @description Search query (minimum 3 characters)
                 * @example Samsung Galaxy S24
                 */
                q: string;
                /**
                 * @description Search type: null = default text search, 'barcode' = direct ID lookup (skips Amazon integration)
                 * @example barcode
                 */
                searchType?: string;
                /**
                 * @description Page size (1-100)
                 * @example 20
                 */
                size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Search results returned successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProductSearchItemDto"];
                };
            };
            /** @description Invalid search query (too short or empty) */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProductSearchItemDto"];
                };
            };
        };
    };
    listAllFormsOfMetadata: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["RepresentationModelObject"];
                };
            };
        };
    };
    descriptor: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                    "application/alps+json": string;
                    "application/schema+json": components["schemas"]["JsonSchema"];
                };
            };
        };
    };
    descriptor_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                    "application/alps+json": string;
                    "application/schema+json": components["schemas"]["JsonSchema"];
                };
            };
        };
    };
    descriptor_2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                    "application/alps+json": string;
                    "application/schema+json": components["schemas"]["JsonSchema"];
                };
            };
        };
    };
    descriptor_3: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string;
                    "application/alps+json": string;
                    "application/schema+json": components["schemas"]["JsonSchema"];
                };
            };
        };
    };
    "getItemResource-project-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Project UUID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelProject"];
                };
            };
            /** @description Project not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDto"];
                };
            };
        };
    };
    "followPropertyReference-project-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelCharity"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-project-get_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelCharity"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProjectDetail: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Project ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDetailedDto"];
                };
            };
        };
    };
    "followPropertyReference-project-get_2": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelFieldOfWork"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-project-get_3": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelFieldOfWork"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getRelatedProjects: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path: {
                /** @description Project ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProjectDetailedDto"];
                };
            };
        };
    };
    getProjectStatistics: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Project ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectStatisticsDto"];
                };
            };
        };
    };
    getProjectSupporters: {
        parameters: {
            query: {
                pageable: components["schemas"]["Pageable"];
            };
            header?: never;
            path: {
                /** @description Project ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProjectSupporterDto"];
                };
            };
        };
    };
    getProjectTransactions: {
        parameters: {
            query: {
                pageable: components["schemas"]["Pageable"];
            };
            header?: never;
            path: {
                /** @description Project ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDto"];
                };
            };
        };
    };
    getProjectBySlug: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Project slug */
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDto"];
                };
            };
            /** @description Project not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDto"];
                };
            };
        };
    };
    getProjectDetailBySlug: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Project slug */
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDetailedDto"];
                };
            };
            /** @description Project not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProjectDetailedDto"];
                };
            };
        };
    };
    search: {
        parameters: {
            query: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Search term to match against project name, description, charity name, or field of work */
                searchTerm: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProjectDetailedDto"];
                };
            };
        };
    };
    previewProjectSlug: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SlugPreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SlugPreviewResponse"];
                };
            };
        };
    };
    validateProjectSlug: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SlugValidateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SlugValidateResponse"];
                };
            };
        };
    };
    getProjectsForCertifiedCharities: {
        parameters: {
            query?: {
                /** @description Field of work ID to filter projects by */
                fieldOfWorkId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Sort by popularity (name-based placeholder) */
                popular?: boolean;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProjectDetailedDto"];
                };
            };
        };
    };
    getCertifiedProjectsByField: {
        parameters: {
            query: {
                /** @description Field of work ID to filter projects by */
                fieldOfWorkId: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProjectDetailedDto"];
                };
            };
        };
    };
    getReleaseNotes: {
        parameters: {
            query?: {
                /** @description Optional category filter */
                category?: components["schemas"]["ReleaseNoteCategory"];
                /** @description Maximum importance level (inclusive) */
                maxImportance?: number;
                /** @description Minimum importance level (inclusive) */
                minImportance?: number;
                /** @description Page number (0-indexed) */
                page?: number;
                /** @description Only return notes published after this timestamp (ISO 8601) */
                publishedAfter?: string;
                /** @description Only return notes published before this timestamp (ISO 8601) */
                publishedBefore?: string;
                /** @description Optional full-text search term */
                search?: string;
                /** @description Page size */
                size?: number;
                /** @description Field to sort by */
                sortBy?: string;
                /** @description Sort direction (asc or desc) */
                sortDirection?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseDtoReleaseNoteListDto"];
                };
            };
        };
    };
    getReleaseNoteBySlug: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Release note slug */
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ReleaseNoteDetailDto"];
                };
            };
        };
    };
    getAvailableCategories: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ReleaseNoteCategory"][];
                };
            };
        };
    };
    getAllShops: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional status filter (default: ACTIVE) */
                status?: components["schemas"]["ShopStatus"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    "getItemResource-shop-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop UUID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["EntityModelShop"];
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
        };
    };
    updateShop: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateShopAdminRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
            /** @description Invalid slug or payload */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
            /** @description Slug already taken */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
        };
    };
    "followPropertyReference-shop-get": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelCategory"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-shop-get_1": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelCategory"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getExtensionConfig: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: components["schemas"]["ShopExtensionConfigDto"];
                    };
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: components["schemas"]["ShopExtensionConfigDto"];
                    };
                };
            };
        };
    };
    saveExtensionConfig: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: components["schemas"]["ShopExtensionConfigDto"];
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: components["schemas"]["ShopExtensionConfigDto"];
                    };
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": {
                        [key: string]: components["schemas"]["ShopExtensionConfigDto"];
                    };
                };
            };
        };
    };
    "followPropertyReference-shop-get_2": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelMerchant"];
                    "text/uri-list": string;
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "followPropertyReference-shop-get_3": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
                propertyId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["CollectionModelMerchant"];
                };
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getRelatedShops: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    uploadShopLogo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Logo image file
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadLogoResponse"];
                };
            };
            /** @description File is empty */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadLogoResponse"];
                };
            };
            /** @description Logo upload failed */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UploadLogoResponse"];
                };
            };
        };
    };
    getByCategory: {
        parameters: {
            query: {
                /** @description Category ID to filter shops by */
                categoryId: string;
                /** @description Page number (0-indexed) */
                page?: number;
                /** @description Page size */
                size: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    getShopBySlug: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop slug */
                slug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
        };
    };
    getUpdatedShops: {
        parameters: {
            query?: {
                /** @description Only return shops updated after this timestamp (ISO-8601); omit for full sync */
                updatedAfter?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UpdatedShopsResponse"];
                };
            };
        };
    };
    getPopularShops: {
        parameters: {
            query: {
                /** @description Page number (0-indexed) */
                page?: number;
                /** @description Page size */
                size: number;
                /** @description Optional status filter (default: ACTIVE) */
                status?: components["schemas"]["ShopStatus"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    searchShops: {
        parameters: {
            query: {
                /** @description Optional category UUID to scope search results to a single category */
                categoryId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional status filter (default: ACTIVE) */
                status?: components["schemas"]["ShopStatus"][];
                /** @description Search term to match against shop names, descriptions, or category names */
                term: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    previewShopSlug: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SlugPreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SlugPreviewResponse"];
                };
            };
        };
    };
    validateShopSlug: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SlugValidateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SlugValidateResponse"];
                };
            };
        };
    };
    getShopsWithAssociations: {
        parameters: {
            query?: {
                /** @description Optional category ID to filter shops by */
                categoryId?: string;
                /** @description Filter shops by contract status (only shops with at least one matching contract) */
                contractStatus?: components["schemas"]["ContractStatus"];
                /** @description Filter shops created at or after this timestamp (ISO-8601) */
                createdAtFrom?: string;
                /** @description Filter shops created at or before this timestamp (ISO-8601) */
                createdAtTo?: string;
                /** @description Filter shops by merchant status (only shops with at least one matching merchant) */
                merchantStatuses?: components["schemas"]["MerchantStatus"][];
                /** @description Filter by monetization (true = has active CPA/CPL contract, false = does not) */
                monetized?: boolean;
                /** @description Optional shop name substring filter (case-insensitive) */
                name?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional status filter (default: ACTIVE) */
                status?: components["schemas"]["ShopStatus"][];
                /** @description Filter for shops with no categories assigned */
                uncategorized?: boolean;
                /** @description Filter shops updated at or after this timestamp (ISO-8601) */
                updatedAtFrom?: string;
                /** @description Filter shops updated at or before this timestamp (ISO-8601) */
                updatedAtTo?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseShopDto"];
                };
            };
        };
    };
    getShopsWithAssociationsById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Shop ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
            /** @description Shop not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"];
                };
            };
        };
    };
    createShop: {
        parameters: {
            query: {
                /** @description Category IDs to assign to the shop */
                categoryIds: string[];
                /** @description Shop description */
                description: string;
                /** @description Optional merchant IDs to associate with the shop */
                merchantIds?: string[];
                /** @description Shop name */
                name: string;
                /** @description Shop status */
                status: components["schemas"]["ShopStatus"];
                /** @description Shop website URL */
                websiteUrl: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description Created */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No categories provided, or invalid input */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Logo upload or database save failed */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    handleWebhook: {
        parameters: {
            query?: never;
            header: {
                "Stripe-Signature": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": string;
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getTransactions: {
        parameters: {
            query?: {
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Optional project ID to filter transactions */
                projectId?: string;
                /** @description Optional shop ID to filter transactions */
                shopId?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDto"];
                };
            };
        };
    };
    getTransactionDetail: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Transaction ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionDetailPublicDto"];
                };
            };
            /** @description Transaction not found or not owned by user */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionDetailPublicDto"];
                };
            };
        };
    };
    getTransactionHistory: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Transaction ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionDetailDto"][];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionDetailDto"][];
                };
            };
            /** @description Transaction not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionDetailDto"][];
                };
            };
        };
    };
    hasUnattributed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["HasUnattributedTransactionsDto"];
                };
            };
        };
    };
    getMetrics: {
        parameters: {
            query?: {
                /** @description Only include transactions created after this timestamp (ISO 8601) */
                createdAtFrom?: string;
                /** @description Only include transactions created before this timestamp (ISO 8601) */
                createdAtTo?: string;
                /** @description Only include transactions updated after this timestamp (ISO 8601) */
                updatedAtFrom?: string;
                /** @description Only include transactions updated before this timestamp (ISO 8601) */
                updatedAtTo?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionMetricsDto"];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["TransactionMetricsDto"];
                };
            };
        };
    };
    getMerchantsWithoutShop: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MissingShopMerchantDto"][];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MissingShopMerchantDto"][];
                };
            };
        };
    };
    getNetworkSummaries: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["NetworkSummaryDto"][];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["NetworkSummaryDto"][];
                };
            };
        };
    };
    listTransactions: {
        parameters: {
            query?: {
                /** @description Optional contract types to filter by (multi-select) */
                contractTypes?: components["schemas"]["ContractType"][];
                /** @description Only include transactions created after this timestamp (ISO 8601) */
                createdAtFrom?: string;
                /** @description Only include transactions created before this timestamp (ISO 8601) */
                createdAtTo?: string;
                /** @description Filter by whether a SENT email notification exists for the current transaction version */
                emailSent?: boolean;
                /** @description Optional merchant ID to filter by */
                merchantId?: string;
                /** @description Optional network ID to filter by */
                networkId?: string;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Optional payment ID to filter by */
                paymentId?: string;
                /** @description Optional search term (max 100 chars) to match against external ID or transaction ID */
                search?: string;
                /** @description Optional shop ID to filter by */
                shopId?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
                /** @description Optional transaction statuses to filter by (multi-select) */
                statuses?: components["schemas"]["TransactionStatus"][];
                /** @description Only include transactions updated after this timestamp (ISO 8601) */
                updatedAtFrom?: string;
                /** @description Only include transactions updated before this timestamp (ISO 8601) */
                updatedAtTo?: string;
                /** @description Optional userFacing flag to filter by */
                userFacing?: boolean;
                /** @description Optional user ID to filter by */
                userId?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDetailDto"];
                };
            };
            /** @description Invalid request parameters */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDetailDto"];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDetailDto"];
                };
            };
        };
    };
    getRecentTransactions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseTransactionDto"];
                };
            };
        };
    };
    listUsers: {
        parameters: {
            query?: {
                /** @description Filter by anonymous user status */
                anonymous?: boolean;
                /** @description Only return users created after this timestamp (ISO 8601) */
                createdAtFrom?: string;
                /** @description Only return users created before this timestamp (ISO 8601) */
                createdAtTo?: string;
                /** @description Filter by custom claims (any match) */
                customClaims?: components["schemas"]["CustomClaim"][];
                /** @description Filter by email verified status */
                emailVerified?: boolean;
                /** @description Zero-based page index (0..N) */
                page?: number;
                /** @description Optional search term to filter by name or email */
                searchTerm?: string;
                /** @description The size of the page to be returned */
                size?: number;
                /** @description Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
                sort?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseUserListDto"];
                };
            };
        };
    };
    getUserById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description User ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
            /** @description User not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
        };
    };
    setUserRoles: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description User ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomClaim"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
            /** @description Requires ROLE_ADMIN */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
            /** @description User not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserAdminDetailDto"];
                };
            };
        };
    };
    addUserClaims: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description User ID */
                user_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomClaim"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    removeUserClaims: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description User ID */
                user_id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CustomClaim"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getDonationSummary: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserDonationSummaryDto"];
                };
            };
        };
    };
    createExtensionToken: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ExtensionTokenResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ExtensionTokenResponse"];
                };
            };
        };
    };
    deleteMe: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getRecentlyViewedProducts: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ProductSearchItemDto"][];
                };
            };
        };
    };
    addRecentlyViewedProduct: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddRecentlyViewedProductRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getRecentlyViewedShops: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ShopDto"][];
                };
            };
        };
    };
    addRecentlyViewedShop: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddRecentlyViewedShopRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSearchHistory: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": string[];
                };
            };
        };
    };
    addSearchTerm: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddSearchTermRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    removeSearchTerm: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Search history entry ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getStats: {
        parameters: {
            query?: {
                /** @description Filter by anonymous user status */
                anonymous?: boolean;
                /** @description Only include users created after this timestamp (ISO 8601) */
                createdAtFrom?: string;
                /** @description Only include users created before this timestamp (ISO 8601) */
                createdAtTo?: string;
                /** @description Filter by email verified status */
                emailVerified?: boolean;
                /** @description Optional search term to filter by name or email */
                searchTerm?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserStatsDto"];
                };
            };
        };
    };
    uploadProfilePicture: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Profile picture image file (max 5 MB)
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UploadProfilePictureResponse"];
                };
            };
        };
    };
    upsert: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserDTO"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["UserDTO"];
                };
            };
        };
    };
    createPaymentIntent: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VoucherPaymentIntentRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["VoucherPaymentIntentResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["VoucherPaymentIntentResponse"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["VoucherPaymentIntentResponse"];
                };
            };
        };
    };
    getPurchases: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PurchasedVoucherDto"][];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PurchasedVoucherDto"][];
                };
            };
        };
    };
    getWishlist: {
        parameters: {
            query?: {
                /** @description Page number (0-indexed) */
                page?: number;
                /** @description Page size */
                size?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Wishlist retrieved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProductSearchItemDto"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["PagedResponseProductSearchItemDto"];
                };
            };
        };
    };
    addToWishlist: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Product ID */
                productId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Product added to wishlist */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    removeFromWishlist: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Product ID */
                productId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Product removed from wishlist */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    checkBatchWishlisted: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WishlistBatchCheckRequest"];
            };
        };
        responses: {
            /** @description Batch check result */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistBatchCheckResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistBatchCheckResponse"];
                };
            };
        };
    };
    checkWishlisted: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Product ID */
                productId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Wishlist check result */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistCheckResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistCheckResponse"];
                };
            };
        };
    };
    getWishlistCount: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Wishlist count retrieved */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistCountResponse"];
                };
            };
            /** @description Not authenticated */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["WishlistCountResponse"];
                };
            };
        };
    };
}
export enum AppPlatform {
    ANDROID = "ANDROID",
    IOS = "IOS"
}
export enum BasketDataStatus {
    PENDING = "PENDING",
    VALIDATED = "VALIDATED",
    DENIED = "DENIED",
    DELETED = "DELETED"
}
export enum CharityStatus {
    ACTIVE = "ACTIVE",
    DEACTIVATED = "DEACTIVATED",
    DELETED = "DELETED"
}
export enum ClientClass {
    MOBILE_IOS = "MOBILE_IOS",
    MOBILE_ANDROID = "MOBILE_ANDROID",
    WEBAPP = "WEBAPP",
    BROWSER_EXTENSION = "BROWSER_EXTENSION",
    EMAIL = "EMAIL"
}
export enum CommissionSummaryType {
    AMOUNT = "AMOUNT",
    PERCENTAGE = "PERCENTAGE"
}
export enum ConditionType {
    LOCATION = "LOCATION",
    DEVICE_TYPE = "DEVICE_TYPE",
    PRODUCT_CATEGORY = "PRODUCT_CATEGORY",
    CUSTOM = "CUSTOM"
}
export enum ContractStatus {
    APPLIED = "APPLIED",
    REJECTED = "REJECTED",
    BLOCKED = "BLOCKED",
    ACTIVATED = "ACTIVATED",
    SUSPENDED = "SUSPENDED",
    TERMINATED = "TERMINATED",
    NOT_APPLIED = "NOT_APPLIED"
}
export enum ContractType {
    CPA = "CPA",
    CPC = "CPC",
    CPL = "CPL"
}
export enum CustomClaim {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_USER = "ROLE_USER",
    ROLE_ANONYMOUS = "ROLE_ANONYMOUS"
}
export enum DatafeedCompression {
    UNCOMPRESSED = "UNCOMPRESSED",
    GZIP = "GZIP",
    ZIP = "ZIP"
}
export enum DatafeedFormat {
    AWIN = "AWIN",
    AWIN_GOOGLE = "AWIN_GOOGLE",
    CJ_SHOPPING = "CJ_SHOPPING"
}
export enum DiscountCodeStatus {
    ACTIVE = "ACTIVE",
    EXPIRED = "EXPIRED",
    DISABLED = "DISABLED"
}
export enum EmailSentStatus {
    QUEUED = "QUEUED",
    SENT = "SENT",
    FAILED = "FAILED",
    SKIPPED = "SKIPPED"
}
export enum FileType {
    CREDIT_NOTE = "CREDIT_NOTE",
    TRANSACTION_LIST = "TRANSACTION_LIST"
}
export enum Gender {
    NOT_KNOWN = "NOT_KNOWN",
    MALE = "MALE",
    FEMALE = "FEMALE",
    NOT_APPLICABLE = "NOT_APPLICABLE"
}
export enum GoverningBody {
    FEDERAL_BOARD = "FEDERAL_BOARD",
    FACILITY_MANAGEMENT = "FACILITY_MANAGEMENT",
    GENERAL_BOARD = "GENERAL_BOARD",
    EXECUTIVE_BOARD = "EXECUTIVE_BOARD",
    MANAGEMENT = "MANAGEMENT",
    COORDINATION_COMMITTEE = "COORDINATION_COMMITTEE",
    FOUNDATION_BOARD = "FOUNDATION_BOARD",
    ADMINISTRATIVE_COMMITTEE = "ADMINISTRATIVE_COMMITTEE",
    BOARD = "BOARD",
    OTHER = "OTHER"
}
export enum LegalForm {
    ASSOCIATION = "ASSOCIATION",
    FOUNDATION = "FOUNDATION",
    GMBH = "GMBH",
    LEGALLY_DEPENDENT = "LEGALLY_DEPENDENT",
    PUBLIC_LAW_CORPORATION = "PUBLIC_LAW_CORPORATION",
    GGMBH = "GGMBH",
    UG = "UG",
    INCORPORATED_ASSOCIATION = "INCORPORATED_ASSOCIATION",
    HISTORIC_ASSOCIATION = "HISTORIC_ASSOCIATION",
    AG = "AG",
    SARL = "SARL",
    OTHER = "OTHER"
}
export enum MatchUsedColumn {
    DB_GTIN = "DB_GTIN",
    DB_EAN = "DB_EAN",
    DB_ISBN = "DB_ISBN",
    DB_UPC = "DB_UPC",
    DB_PARENT_PRODUCT_ID = "DB_PARENT_PRODUCT_ID",
    DB_MERCHANT_PRODUCT_ID = "DB_MERCHANT_PRODUCT_ID",
    NEW_GTIN = "NEW_GTIN",
    NEW_EAN = "NEW_EAN",
    NEW_ISBN = "NEW_ISBN",
    NEW_UPC = "NEW_UPC",
    NEW_PARENT_PRODUCT_ID = "NEW_PARENT_PRODUCT_ID",
    NEW_MERCHANT_PRODUCT_ID = "NEW_MERCHANT_PRODUCT_ID"
}
export enum MerchantStatus {
    ACTIVE = "ACTIVE",
    DEACTIVATED = "DEACTIVATED",
    DELETED = "DELETED"
}
export enum NetworkType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    VERTICAL = "VERTICAL",
    AGENCY = "AGENCY",
    META = "META"
}
export enum OverheadCostType {
    LOW = "LOW",
    ACCEPTABLE = "ACCEPTABLE",
    APPROPRIATE = "APPROPRIATE"
}
export enum PaymentConsistencyStatus {
    CONSISTENT = "CONSISTENT",
    INCONSISTENT = "INCONSISTENT",
    UNCHECKED = "UNCHECKED"
}
export enum PaymentStatus {
    UNCONFIRMED = "UNCONFIRMED",
    CONFIRMED = "CONFIRMED",
    REVERSED = "REVERSED",
    CANCELLED = "CANCELLED"
}
export enum ProcessedStatus {
    SCHEDULED = "SCHEDULED",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED"
}
export enum ProjectStatus {
    ACTIVE = "ACTIVE",
    DEACTIVATED = "DEACTIVATED",
    DELETED = "DELETED"
}
export enum ReleaseNoteCategory {
    FEATURE = "FEATURE",
    IMPROVEMENT = "IMPROVEMENT",
    BUGFIX = "BUGFIX",
    BREAKING_CHANGE = "BREAKING_CHANGE"
}
export enum ShopStatus {
    ACTIVE = "ACTIVE",
    DEACTIVATED = "DEACTIVATED"
}
export enum SocialMediaPlatform {
    WEBSITE = "WEBSITE",
    FACEBOOK = "FACEBOOK",
    INSTAGRAM = "INSTAGRAM",
    TWITTER = "TWITTER",
    LINKEDIN = "LINKEDIN",
    YOUTUBE = "YOUTUBE",
    TIKTOK = "TIKTOK",
    SNAPCHAT = "SNAPCHAT",
    PINTEREST = "PINTEREST",
    REDDIT = "REDDIT",
    DISCORD = "DISCORD",
    THREADS = "THREADS",
    XING = "XING",
    TELEGRAM = "TELEGRAM",
    WHATSAPP = "WHATSAPP",
    SIGNAL = "SIGNAL",
    WECHAT = "WECHAT",
    SLACK = "SLACK",
    MASTODON = "MASTODON",
    TWITCH = "TWITCH",
    VIMEO = "VIMEO",
    DAILYMOTION = "DAILYMOTION",
    MIXER = "MIXER",
    KICK = "KICK",
    GITHUB = "GITHUB",
    GITLAB = "GITLAB",
    STACKOVERFLOW = "STACKOVERFLOW",
    DRIBBBLE = "DRIBBBLE",
    BEHANCE = "BEHANCE",
    SPOTIFY = "SPOTIFY",
    SOUNDCLOUD = "SOUNDCLOUD",
    APPLE_MUSIC = "APPLE_MUSIC",
    BANDCAMP = "BANDCAMP",
    WEIBO = "WEIBO",
    QQ = "QQ",
    DOUYIN = "DOUYIN",
    BILIBILI = "BILIBILI",
    VK = "VK",
    LINE = "LINE",
    KAKAOTALK = "KAKAOTALK",
    MEDIUM = "MEDIUM",
    TUMBLR = "TUMBLR",
    QUORA = "QUORA",
    CLUBHOUSE = "CLUBHOUSE",
    PATREON = "PATREON",
    ONLYFANS = "ONLYFANS",
    SUBSTACK = "SUBSTACK"
}
export enum SoftwareVendor {
    CUSTOM = "CUSTOM",
    INGENIOUS = "INGENIOUS",
    EASY_MARKETING = "EASY_MARKETING"
}
export enum TransactionStatus {
    PENDING = "PENDING",
    VALIDATED = "VALIDATED",
    RECEIVED = "RECEIVED",
    PAID = "PAID",
    DENIED = "DENIED",
    DELETED = "DELETED"
}
export enum UserStatus {
    ACTIVE = "ACTIVE",
    DELETED = "DELETED"
}
export enum VoucherPurchaseStatus {
    PENDING = "PENDING",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED"
}
export enum Worldview {
    INDEPENDENT = "INDEPENDENT",
    CHRISTIAN = "CHRISTIAN",
    CATHOLIC = "CATHOLIC",
    PROTESTANT = "PROTESTANT",
    ORTHODOX = "ORTHODOX",
    JEWISH = "JEWISH",
    MUSLIM = "MUSLIM",
    BUDDHIST = "BUDDHIST",
    HINDU = "HINDU",
    ATHEIST = "ATHEIST",
    AGNOSTIC = "AGNOSTIC",
    OTHER = "OTHER"
}
